import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'axios';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxNotificationComponent } from 'jqwidgets-ng/jqxnotification';
import { NgxSpinnerService } from 'ngx-spinner';
import { asyncScheduler, firstValueFrom } from 'rxjs';
import { BackendService } from 'src/app/services/backend.service';
import Hls from 'hls.js';
import { ExcelService } from 'src/app/services/excel.service';
import { FileAccessService } from 'src/app/services/fileaccess.service';
import Swal from 'sweetalert2';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { RecordingModel } from 'src/app/models/apiRequestModels';
import { FieldType } from 'src/app/models/field-definition';
import { FormDataEntry, parseFormDataSnapshot } from 'src/app/shared/dynamic-form/form-data-snapshot';
import { buildAnnotationSpeakers } from 'src/app/shared/dynamic-form/annotation-speakers';
import { AnnotationDialogModel, Annotations, AnnotationSpeaker, GetFileUploadModel } from 'src/app/models/StreamingModels';
import { AnnotationsComponent } from 'src/app/adminpages/audiostreaming/annotations.component';
import { AnnotationComponent } from 'src/app/adminpages/audiostreaming/annotation/annotation.component';
import FroalaEditor from 'froala-editor';
import 'froala-editor/js/plugins/lists.min.js';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatRadioChange } from '@angular/material/radio';
import { PlaybackChannelMixer } from '../channel-mixer';


declare var tippy: any;
declare const $: any;
let PageNumberGlobal: any;
let customStartDateContainer: any;
let customEndDateContainer: any;
let customsearchButtonContainer: any;
interface TranscriptResponse {
  type: string;
  participant: string;
  participant_identity: string;
  same_speaker: boolean | undefined;
  speaker: string;
  text: string;
  translated_text: string;
  translation_target: any;
  is_final: boolean;
  confidence: number;
  language: string;
  timestamp: number;
  duration: number;
  words: TranscriptWord[];
  created_at: string;
}

interface TranscriptWord {
  word: string;
  start: number;
  end: number;
  confidence?: number;
}
interface TranscriptionViewSegment {
  speaker: string;
  speakerNumber: number;
  speakerKey: string;
  text: string;
  translatedText: string;
  translationTarget?: string;
  language?: string;
  timestamp: number;
  startTime: number;
  endTime: number;
  trackId?: string;
  duration: number;
}


interface ActiveSegment {
  realStart: number;
  realEnd: number;
  virtualStart: number;
  virtualEnd: number;
}

interface CaseTranscriptionSegment {
  startMs: number;
  endMs: number;
  html: string;
}

interface CaseDetailRow {
  id: number;
  caseNumber: string;
  judgeName: string;
  hearingDateTime: Date | null;
  startedAt: Date | null;
  stoppedAt: Date | null;
  durationText: string;
  formEntries: FormDataEntry[];
}
@Component({
  selector: 'app-audiostreaming-list',
  templateUrl: './audiostreaming-list.component.html',
  styleUrls: ['./audiostreaming-list.component.css']
})
export class AudiostreamingListComponent implements OnInit {

  private static readonly DETAIL_STORAGE_KEY_PREFIX = 'audiostreaming-list-detail-';
  private static readonly DETAIL_STORAGE_MAX_AGE_MS = 60 * 60 * 1000;

  @ViewChild('audioRef', { static: false }) audioRef!: ElementRef<HTMLAudioElement>;
  @ViewChild('summaryWindow', { static: false }) summaryWindow!: jqxWindowComponent;
  @ViewChild('summaryPromptDDL', { static: false }) summaryPromptDDL: any;
  @ViewChild('customPrompt') customPromptRef!: ElementRef<HTMLTextAreaElement>;

  hidestatus: string = '';
  customSearch = false;
  selectedStartDate: any;
  selectedEndDate: any;
  startmin: any;
  startmax: any;
  endmin: any;
  endmax: any;
  mode: string = ''
  recordingindex: any[] = [];
  completedJobIdArray: any[] = [];
  requiredJobsArray = [];
  nonRequiredJobsArray = [];
  NumberOfRecordings = 0;
  MinEndDate: any;
  MaxStartDate: any;
  endDateEvent = false;
  selectedDateOption: any;
  selectedStatusOption: string = '';
  UnixStartDate: any;
  UnixEndDate: any;
  selectedDDLindex: any;
  totalCountGlobal: any;
  IsSqlDB = false;
  token: any;
  buttonCounter: any;
  sqlData: any;
  isRefresh = false;
  IsAudioPlay: boolean = false;
  element = $("<div id = 'gridpager' style='margin-left: 10px; margin-top: 11px; width: 100%; height: 100%;'></div>");
  progress: number = 0;
  heightOffset: number = 120;
  selectedIndex: number = 0;
  dateRange: string = '';
  DisplayCustomStartDate: any;
  DisplayCustomEnddate: any;
  editmode = '';
  recordingArray: any[] = [];
  filesize: number = 0;
  downloadFilesArray: any[] = [];
  audioList: string[] = [];
  currentAudioIndex: number = 0;
  audioCurrentTime: number = 0;
  audioDuration: number = 0;
  audioProgressPercent: number = 0;
  audioVolume: number = 1;
  isAudioPlaying: boolean = false;
  audioStarted: boolean = false;
  statusValue: string = '';
  sourceValue: string = '';
  organizationOptions: any[] = [];
  departmentOptions: any[] = [];
  departmentDropdownOptions: any[] = [];
  selectedOrgExtId = "";
  selectedDepartmentId = "";
  selectedDepartmentExtId = "";
  recordingIndex: any[] = [];
  public selectedRecording: RecordingModel = {};
  selectedRecordingIsCourt = false;
  public formDetails: FormDataEntry[] = [];
  finalTranscriptionSegments: TranscriptionViewSegment[] = [];
  transcriptionText: string = '';
  wordCount: number = 0;
  characterCount: number = 0;
  lastUpdated: Date | null = null;
  private activeSegments: ActiveSegment[] = [];
  private mediaIncludesPauseGaps = true;
  caseDetailRows: CaseDetailRow[] = [];
  get recordingCaseReferenceLabel(): string {
    for (const row of this.caseDetailRows) {
      const uniqueField = row.formEntries.find(entry => entry.unique);
      if (uniqueField?.label) {
        return uniqueField.label;
      }
    }
    return this.formDetails.find(entry => entry.unique)?.label || 'Referance';
  }
  selectedCaseDetail: CaseDetailRow | null = null;
  // Speakers for the annotation panel: the selected case's saved form, else the recording's own.
  annotationSpeakers: AnnotationSpeaker[] = [];
  isCaseDetailsPanelExpanded: boolean = true;
  private caseWindowStart: number = 0;
  private caseWindowEnd: number | null = null;
  private caseFilteredTranscriptionHtml: string | null = null;
  private caseDetailsByRecordingId = new Map<number, any[]>();
  private static readonly SEGMENT_TIME_PATTERN = /\[\s*(\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2})\s*-\s*(\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2})\s*\]/;

  // Froala Editor mode properties
  isTranscriptionEditMode: boolean = false;
  private _editableTranscriptionContent: string = '';
  get editableTranscriptionContent(): string {
    return this._editableTranscriptionContent;
  }
  set editableTranscriptionContent(value: string) {
    this._editableTranscriptionContent = value || '';
    // Keep a plain-text snapshot for statistics
    this.transcriptionText = this.stripHtmlTags(this._editableTranscriptionContent);
    this.updateTranscriptionStats();
    this.applyCaseTranscriptionFilter(this.selectedCaseDetail);
  }
  activeFroalaEditor: any = null;
  showFindReplacePanel = false;
  findWhatText = '';
  replaceWithText = '';
  isFindReplaceCaseSensitive = false;
  isFindReplaceMatchWord = false;
  findReplaceCurrentIndex = 0;
  findReplaceMatches: number[] = [];
  allowTranscriptEditing = (localStorage.getItem("allowTranscriptEditing")) == 'true' ? true : false;
  selectedPromptId: number = -1;
  customPromptText = '';
  summaryPrompt: string = "";
  showCustomPrompt: boolean = false;
  summaryText: string;
  presetPromptsOptions: any[] = [];
  promptOptions = [];
  promptMode: 'summary' | 'custom' = 'summary';
  HaveTranscription: boolean = true;
  // Froala Editor configuration
  // froalaOptions = {
  //   key: localStorage.getItem('FroalaLicense'),
  //   toolbarSticky: true,
  //   contenteditable: true,
  //   toolbarInline: true,
  //   toolbarVisibleWithoutSelection: false,
  //   listAdvancedTypes: false,
  //   toolbarButtons: ['bold', 'italic', 'underline', 'formatUL', 'formatOL', '|', 'add-speaker', '|', 'undo', 'redo', 'allCaps', 'find-replace'],
  //   useClasses: true,
  //   tabSpaces: 4,
  //   htmlUntouched: true,
  //   pluginsEnabled: ['lists'],
  //   placeholderText: 'Edit transcription here...',
  //   charCounterCount: false,
  //   wordCounterCount: false,
  //   heightMin: 400,
  //   heightMax: 800,
  //   paragraphFormat: {
  //     N: 'Normal',
  //     H2: 'Heading 2',
  //     H3: 'Heading 3',
  //     H4: 'Heading 4',
  //     PRE: 'Code'
  //   },
  //   htmlAllowedAttrs: [
  //     'style',
  //     'class',
  //     'contenteditable',
  //     'id',
  //     'dir',
  //     'lang'
  //   ],

  //   // Allow p, span, em, strong, div, and other structural tags
  //   htmlAllowedTags: [
  //     'p',
  //     'span',
  //     'em',
  //     'strong',
  //     'b',
  //     'i',
  //     'div',
  //     'br'
  //   ],
  //   htmlRemoveTags: [],
  //   pasteAllowLocalImages: false,
  //   pasteDeniedAttrs: [],

  //   // Maintain white-space and formatting
  //   keepFormatOnDelete: true,
  //   fontFamily: {
  //     'Segoe UI,Roboto,Helvetica,Arial,sans-serif': 'Segoe UI',
  //     'Georgia,serif': 'Georgia',
  //     'Courier New,monospace': 'Courier New'
  //   },
  //   events: {
  //     initialized: function () {
  //       // In Froala options, 'this' inside a standard function refers directly to the editor instance
  //       const editor = this;

  //       // Assign to component instance variable safely
  //       // (Ensure you save component reference 'self = this' outside if 'this' gets shadowed, or use arrow function with safe checks below)
  //     },
  //     'froalaEditor.initialized': (e: any, editor: any) => {
  //       // Get the editor instance safely across different Froala wrapper versions
  //       const instance = editor || (e && e.target ? e.target.froalaEditor : null);

  //       if (instance) {
  //         this.activeFroalaEditor = instance;

  //         // Safe check for edit mode initialization
  //         if (instance.edit && typeof instance.edit.on === 'function') {
  //           instance.edit.on();
  //         }

  //         // Ensure DOM element exists before attaching contextmenu listener
  //         if (instance.el) {
  //           instance.el.addEventListener('contextmenu', (event: MouseEvent) => {
  //             event.preventDefault();
  //             if (instance.toolbar && typeof instance.toolbar.showInline === 'function') {
  //               instance.toolbar.showInline(event.pageX, event.pageY);
  //             }
  //           });
  //         }
  //       }
  //     }
  //   }
  // };
  froalaOptions: Record<string, any> = {
    key: localStorage.getItem('FroalaLicense'),
    toolbarSticky: true,
    toolbarInline: true,
    contenteditable: false,
    // toolbarInline: false, // Set to false to prevent invisible/blank toolbar issues
    listAdvancedTypes: false,

    // ALL plugins used by toolbar buttons MUST be enabled explicitly
    pluginsEnabled: [
      'lists',
      'undo',
      'paragraphFormat',
      'fontFamily',
      'align',
      'wordPaste'
    ],

    toolbarButtons: [
      'bold', 'italic', 'underline', 'formatUL', 'formatOL',
      '|', 'add-speaker', '|', 'undo', 'redo', 'find-replace'
    ],

    useClasses: true,
    tabSpaces: 4,
    htmlUntouched: true,
    placeholderText: 'Edit transcription here...',
    charCounterCount: false,
    wordCounterCount: false,
    heightMin: 400,
    heightMax: 800,

    paragraphFormat: {
      N: 'Normal',
      H2: 'Heading 2',
      H3: 'Heading 3',
      H4: 'Heading 4',
      PRE: 'Code'
    },

    htmlAllowedAttrs: ['style', 'class', 'contenteditable', 'id', 'dir', 'lang'],
    htmlAllowedTags: ['p', 'span', 'em', 'strong', 'b', 'i', 'div', 'br'],
    htmlRemoveTags: [],
    pasteAllowLocalImages: false,
    pasteDeniedAttrs: [],
    keepFormatOnDelete: true,

    fontFamily: {
      'Segoe UI,Roboto,Helvetica,Arial,sans-serif': 'Segoe UI',
      'Georgia,serif': 'Georgia',
      'Courier New,monospace': 'Courier New'
    },

    events: {
      initialized: () => {
        // Safe binding inside Angular component
      }
    }
  };
  // Bypass security sanitization for [innerHTML] binding in read-only mode
  get transcriptionDisplayHtml(): string {
    return this.caseFilteredTranscriptionHtml !== null
      ? this.caseFilteredTranscriptionHtml
      : this.editableTranscriptionContent;
  }

  get sanitizedTranscriptionContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.transcriptionDisplayHtml);
  }
  constructor(private backendService: BackendService,
    private excelService: ExcelService,
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private fileaccess: FileAccessService,
    private cdRef: ChangeDetectorRef,
    private annotationsComponent: AnnotationsComponent,
    private sanitizer: DomSanitizer
  ) { }
  @ViewChild('myGrid', { static: false }) myGrid!: jqxGridComponent;
  @ViewChild('transcriptionDisplay', { static: false }) transcriptionDisplay?: ElementRef<HTMLDivElement>;
  @ViewChild('msgNotification', { static: false }) msgNotification!: jqxNotificationComponent;
  @ViewChild('myDropDownList', { static: false }) myDropDownList!: jqxDropDownListComponent;
  @ViewChild('myDateDropDownList', { static: false }) myDateDropDownList!: jqxDropDownListComponent;
  @ViewChild('viewRecordingDetails', { static: false }) viewRecordingDetails!: jqxWindowComponent;
  @ViewChild('annotationComp', { static: false }) annotationComp?: AnnotationComponent;
  @ViewChild('findReplacePopup', { static: false }) findReplacePopup?: jqxWindowComponent;
  @Input() fileToPlay: string = '';
  hlsUrl: string = '';
  private hls?: Hls;
  // Per-channel gain/mute for the player; attached on first open of its channels panel.
  readonly playbackChannels = new PlaybackChannelMixer();
  showTimeline: boolean = false;
  showAnnotationsPanel: boolean = false;
  private previousSidebarView: 'info' | 'timeline' = 'info';
  parsedTimelineData: any = null;
  timelineEvents: any[] = [];
  isAnnotationMaximized: boolean = false;
  isDetailWindowMode: boolean = false;
  detailWindowToken: string = '';
  // These will hold the calculated pixels based on current screen size
  windowWidth: number = 1200;
  windowHeight: number = 800;

  setAnnotationDetailVisibility(isMaximized: boolean): void {
    this.isAnnotationMaximized = isMaximized;
  }
  setAudioPlayerPosition(durationSec: Number): void {
    const seconds = Number(durationSec) || 0;
    console.log("setAudioPlayerPosition... ", seconds, this.selectedRecording?.startedAt);

    this.audioCurrentTime = seconds;
    this.scrollTranscriptionToTime(seconds);

    if (this.audioRef?.nativeElement) {
      this.seekTo(seconds);
      return;
    }

    this.audioProgressPercent = this.audioDuration ? Math.min(100, (seconds / this.audioDuration) * 100) : 0;
  }

  // Scrolls the read-only transcript to the segment spoken at the given player (virtual) time.
  // Segment headers carry wall-clock times ("[yyyy-MM-dd HH:mm:ss - ...]"), so the player time is
  // mapped back through any pauses to a wall-clock instant first.
  private scrollTranscriptionToTime(virtualSeconds: number): void {
    const display = this.transcriptionDisplay?.nativeElement;
    const audioStartMs = this.selectedRecording?.startedAt
      ? new Date(this.selectedRecording.startedAt).getTime()
      : NaN;
    if (!display || this.isTranscriptionEditMode || isNaN(audioStartMs)) {
      return;
    }

    const realSeconds = this.activeSegments.length ? this.mapVirtualToReal(virtualSeconds) : virtualSeconds;
    const targetMs = audioStartMs + realSeconds * 1000;

    let target: HTMLElement | null = null;
    let targetStartMs = -Infinity;
    let first: HTMLElement | null = null;
    for (const element of Array.from(display.querySelectorAll('p, div, li')) as HTMLElement[]) {
      if (!this.isSegmentStartElement(element)) {
        continue;
      }
      const range = this.extractSegmentTimeRange(element.textContent || '');
      if (!range) {
        continue;
      }
      first = first || element;
      // Header times are whole seconds, so allow a second of slack.
      if (range.startMs <= targetMs + 1000 && range.startMs >= targetStartMs) {
        target = element;
        targetStartMs = range.startMs;
      }
    }

    target = target || first;
    if (!target) {
      return;
    }

    // Either the display or the view-mode wrapper scrolls depending on layout.
    const scroller = [display, display.parentElement]
      .find(element => !!element && element.scrollHeight > element.clientHeight) || display;
    const offset = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
    scroller.scrollTo({ top: scroller.scrollTop + offset - 8, behavior: 'smooth' });
    this.flashTranscriptionElement(target);
  }

  private flashTranscriptionElement(element: HTMLElement): void {
    element.style.transition = 'background-color 0.4s ease';
    element.style.backgroundColor = '#fff3cd';
    setTimeout(() => element.style.backgroundColor = '', 2000);
  }
  startDateEventOpen(event: any): void {
    this.endDateEvent = false;
  }

  onStartDateValueChanged(event: any): void {
    if (this.endDateEvent == false) {
      var selecteddate = event.args.date;
      var dateevent = new Date();
      this.MinEndDate = selecteddate.setDate(selecteddate.getDate());
      this.MinEndDate = new Date(this.MinEndDate);
      this.endmin = new Date(this.MinEndDate);
      this.selectedStartDate = this.datePipe.transform(selecteddate, 'yyyy-MM-ddT00:00')
      this.endmin = new Date(this.selectedStartDate);
      this.DisplayCustomStartDate = new Date(this.selectedStartDate);
    }
  }

  onEndDateValueChanged(event: any): void {
    this.endDateEvent = true;
    var selecteddate = event.args.date;
    var dateevent = new Date();
    this.MaxStartDate = selecteddate.setDate(selecteddate.getDate());
    this.MaxStartDate = new Date(this.MaxStartDate);
    this.startmax = new Date(this.MaxStartDate);
    this.selectedEndDate = this.datePipe.transform(selecteddate, 'yyyy-MM-ddT00:00')
    this.DisplayCustomEnddate = new Date(this.selectedEndDate);
  }
  dateOptions: any[] =
    [
      { html: '<div>Today</div>', title: 'Today' },
      { html: '<div>Yesterday</div>', title: 'Yesterday' },
      { html: '<div>This week</div>', title: 'This week (Sunday to today)' },
      { html: '<div>Last 7 days</div>', title: 'Last 7 days (six days ago to today)' },
      { html: '<div>This month</div>', title: 'This month (1st of this month to today)' },
      { html: '<div>Last 31 days</div>', title: 'Last 31 days (30 days ago to today)' },
      { html: '<div>Custom Date Range</div>', title: 'Custom' },
    ];
  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    let stringcomparisonoperators = ['EMPTY', 'NOT_EMPTY', 'CONTAINS', 'DOES_NOT_CONTAIN', 'STARTS_WITH', 'ENDS_WITH', 'EQUAL'];
    let numericcomparisonoperators = ['LESS_THAN', 'GREATER_THAN'];
    let datecomparisonoperators = ['LESS_THAN', 'GREATER_THAN'];
    let booleancomparisonoperators = ['EQUAL', 'NOT_EQUAL'];
    switch (type) {
      case 'stringfilter':
        return stringcomparisonoperators;
      case 'numericfilter':
        return numericcomparisonoperators;
      case 'datefilter':
        return datecomparisonoperators;
      case 'booleanfilter':
        return booleancomparisonoperators;
      default:
        this.spinner.hide();
        return [];
    }
  };
  height: number = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (!this.isDetailWindowMode && this.viewRecordingDetails) {
      // Re-apply responsive percentage sizes on window resize
      this.viewRecordingDetails.setOptions({
        width: '90%',
        height: '80%'
      });
    }
    this.height = event.target.innerHeight - this.heightOffset;
    this.height = this.height - 30;

  }
  getHeight() {
    this.height = (window.screen.height - this.heightOffset);
    window.dispatchEvent(new Event('resize'));
  }


  getJSONResponse(value: any) {
    return JSON.parse(JSON.stringify(value));
  }
  convertStartDatetoUnix(date: any) {
    var reqstartDate = this.datePipe.transform(date, 'yyyy-MM-dd 00:00:00');
    var StringtoDate = new Date(reqstartDate || '');
    this.UnixStartDate = (StringtoDate.getTime() / 1000);
    this.UnixStartDate = this.UnixStartDate - 1;
  }
  convertEndDatetoUnix(date: any) {
    var reqEndDate = this.datePipe.transform(date, 'yyyy-MM-dd 23:59:59');
    var StringtoDate = new Date(reqEndDate || '');
    this.UnixEndDate = (StringtoDate.getTime() / 1000);
    this.UnixEndDate = this.UnixEndDate + 1;
  }
  onProgressUpdate(newProgress: number) {
    this.progress = newProgress;
  }
  searchData() {
    PageNumberGlobal = 1;
    this.getShowstatus(this.selectedStatusOption);
  }
  ngAfterViewInit(): void {

    setTimeout(() => {
      // TIPPY JS.
      tippy('[data-tippy-content]');
      //Jqxwindow position and size
      if (this.viewRecordingDetails) {
        this.viewRecordingDetails.maxWidth(1900);
        this.viewRecordingDetails.maxHeight(1500);
        // Set your custom width and height for the first time
        this.viewRecordingDetails.width(1370);
        this.viewRecordingDetails.height(660);

        // Set your custom position (Left: 250px, Top: 120px)
        // Syntax: move(left, top)
        this.viewRecordingDetails.move(120, 25);
      }
    }, 500);
    if (this.buttonCounter == 1) {
      this.source.showtoolbar = true;
      this.createButtons();
    }
    let dateOpt = JSON.parse(JSON.stringify(this.dateOptions[0]));
    const tmp = document.createElement('DIV');
    tmp.innerHTML = dateOpt.html;
    this.selectedDateOption = tmp.textContent || tmp.innerText || '';

    if (this.isDetailWindowMode) {
      this.loadDetailWindowRecording();
    }
  }

  async ngOnInit() {
    //console.log("ngOnInit ...", this.allowTranscriptEditing);
    this.registerFroalaEditorCommands();
    this.isDetailWindowMode = this.route.snapshot.queryParamMap.get('detailWindow') === '1';
    this.detailWindowToken = this.route.snapshot.queryParamMap.get('detailToken') || '';

    if (this.isDetailWindowMode) {
      this.calculateWindowSize();
      return;
    }

    const isUserLoggedIn = localStorage.getItem('userloggedIN');
    if (isUserLoggedIn === "false") {
      this.backendService.setUserLoggedIn(false);
    }

    this.spinner.show();

    try {
      //await this.loadOrganizationValues();
      await this.loadDeparmentValues();
      this.statusValue = "All";
      this.sourceValue = "All";
      this.selectedOrgExtId = "All";
      this.dateRange = "Today";

      this.getDatesByOption(this.dateRange);

      this.buttonCounter = 0;
      this.getHeight();

      this.IsSqlDB = true;
      this.spinner.show();

    } catch (error) {
      console.error('Error:', error);
      this.spinner.hide();
    }
  }
  onRowDoubleClick(event: any): void {
    console.log("onRowDoubleClick ...", event);
    // Extract arguments from the event
    const args = event.args;
    const rowIndex = args.rowindex;
    const rowData = args.row.bounddata;
    console.log("rowData ...", rowData);
    this.openRecordingInfo(rowData);
  }
  onPageChanged(event: any): void {
    this.spinner.show();
  }
  recordingGridFilter(event: any): void {
    this.spinner.show();
  }
  getsqlData(startDate: any, endDate: any, status: any, source: any, orgExtId: any, deptExtId: any) {

    this.spinner.show();

    this.buttonCounter++;
    if (this.buttonCounter === 1) {
      this.source.showtoolbar = true;
      this.createButtons();
    }

    this.convertStartDatetoUnix(startDate);
    this.convertEndDatetoUnix(endDate);

    this.source.data = {
      StartDate: this.UnixStartDate,
      EndDate: this.UnixEndDate,
      orgExtId: orgExtId,
      deptExtId: deptExtId,
      status: status,
      recordingsource: source
    };

    this.source.url = this.backendService.getrecordingswithfilterurl();

    //console.log("Calling API:", this.source.url);

    // 🔥 IMPORTANT FIX
    this.myGrid.updatebounddata('data');

    this.isRefresh = false;
  }


  source: any = {
    datatype: 'json',
    datafields: [
      { name: 'recordingSessionId', type: 'string' },
      { name: 'caseNumber', type: 'string' },
      { name: 'judgeFirstName', type: 'string' },
      { name: 'judgeLastName', type: 'string' },
      { name: 'hearingDateTime', type: 'string' },
      { name: 'hostName', type: 'string' },
      { name: 'language', type: 'string' },
      { name: 'status', type: 'string' },
      { name: 'roomName', type: 'string' },
      { name: 'outputPath', type: 'string' },
      { name: 'createdAt', type: 'date' },
      { name: 'courtroom', type: 'string' },
      { name: 'courtLocation', type: 'string' },
      { name: 'translateToEnglish', type: 'string' },
      { name: 'microphone', type: 'string' },
      { name: 'recordingSource', type: 'string' },
      { name: 'sourceSystem', type: 'string' },
      { name: 'recordingDetails', type: 'string' },
      { name: 'stoppedAt', type: 'string' },
      { name: 'startedAt', type: 'string' },
      { name: 'audioChannels', type: 'string' },
      { name: 'fileName', type: 'string' },
      { name: 'format', type: 'string' },
      { name: 'id', type: 'integer' },
      { name: 'postRecordingAnnotationUpdate', type: 'boolean' },
      { name: 'departmentName', type: 'string' },
      { name: 'organizationName', type: 'string' },
      { name: 'orgExtId', type: 'string' },
      { name: 'formData', type: 'string' },
      { name: 'transcriptionFilePath', type: 'string' },
      { name: 'downloadStatus', type: 'string' },
      

    ],
    sortcolumn: 'id',
    sortdirection: 'desc',
    loader: false,
    enablebrowserselection: true,
    keyboardnavigation: false,
    //cache: false,
    // localdata: [],
    beforeprocessing: (data: any) => {
      //console.log("API Response:", data);
      this.source.totalrecords = data.totalRows;
      this.totalCountGlobal = data.totalRows;
      var results = data.rows;
      for (const index in results) {
        const val = results[index];
        this.caseDetailsByRecordingId.set(val.id, Array.isArray(val.caseDetails) ? val.caseDetails : []);
        var reqDate = this.datePipe.transform(val.createdAt, 'yyyy-MM-dd HH:mm:ss UTC');
        val.createdAt = new Date(reqDate || '').toString();
        val.translateToEnglish = val.translateToEnglish ? 'Yes' : 'No';
        val.recordingDetails = val.recordingDetails;
        //hearing date
        // var hearingDate = this.datePipe.transform(val.hearingDateTime, 'EEE MMMM dd yyyy HH:mm:ss UTC');
        // val.hearingDateTime = new Date(hearingDate || '').toString();

        const rawhearingDate = val.hearingDateTime ? String(val.hearingDateTime) : '';
        if (rawhearingDate) {
          const hearingDate = val.hearingDateTime.endsWith('Z') ? val.hearingDateTime : `${val.hearingDateTime}Z`;
          val.hearingDateTime = this.datePipe.transform(hearingDate, 'EEE MMM dd yyyy HH:mm:ss') || '';
        }

        const startedAt = val.startedAt.endsWith('Z') ? val.startedAt : `${val.startedAt}Z`;
        val.startedAt = this.datePipe.transform(startedAt, 'EEE MMM dd yyyy HH:mm:ss') || '';

        const rawstoppedAt = val.stoppedAt ? String(val.stoppedAt) : '';
        if (rawstoppedAt) {
          const stoppedAt = val.stoppedAt.endsWith('Z') ? val.stoppedAt : `${val.stoppedAt}Z`;
          val.stoppedAt = this.datePipe.transform(stoppedAt, 'EEE MMM dd yyyy HH:mm:ss') || '';
        }


      }
      this.sqlData = results;
      this.spinner.hide();

    },
    filter: () => {
      // update the grid and send a request to the server.
      this.myGrid.updatebounddata('filter');
    }, sort: () => {
      // update the grid and send a request to the server.
      this.myGrid.updatebounddata('sort');
    }
  };


  sQLdataAdapter: any = new jqx.dataAdapter(this.source, {
    autoBind: true,
    beforeSend: (jqXHR: any, settings: any) => {
      this.token = localStorage.getItem('token');
      if (this.token == null) {
        jqXHR.abort();
      }
      jqXHR.setRequestHeader('Authorization', 'Bearer ' + this.token);
    },
    contentType: 'application/json; charset=utf-8',
    loadError: (xhr: any, status: any, error: any) => {
      this.sendNotification("Unable to get the Recordings. Please refresh the page.", 'error')
      this.spinner.hide();
    }
  });

  ///////////////////////

  pagerrenderer = () => {
    if (!this.myGrid || typeof this.myGrid.getdatainformation !== 'function') {
      return this.element;
    }

    this.element.empty();
    var datainfo = this.myGrid.getdatainformation();
    if (!datainfo || !datainfo.paginginformation) {
      return this.element;
    }
    var paginginfo = datainfo.paginginformation;
    ///Appending Buttons
    var data = this.myGrid.getrows();
    var jobcount = data.length;
    this.totalCountGlobal = datainfo.rowscount;
    //labels
    var pageSizelabel = $("<div style='font-size: 13px; margin: 2px 100px; margin-top:-4px; font-weight: bold; float: right;'></div>");
    var dropdown = $("<div style='margin-right: -75px; margin-top: -5px; padding: 0px; float: right; cursor: pointer;'> </div>")
    var leftButton = $("<div style='padding: 0px; float: right; cursor: pointer;'><div style='margin-left: 45px; width: 16px; height: 16px;'></div></div>")
    leftButton.find('div').addClass('jqx-icon-arrow-left');
    leftButton.width(36);
    var rightButton = $("<div style='padding: 0px; margin: 0px 3px; float: right; cursor: pointer;'><div style='margin-left: 150px; width: 16px; height: 16px;'></div></div>");
    rightButton.find('div').addClass('jqx-icon-arrow-right');
    rightButton.width(36);

    var CurrentPageJobslabel = $("<div style='font-size: 13px; margin: 2px 0px; margin-top:-4px; font-weight: bold; float: left;'></div>");

    if (jobcount > 0) {
      var data = this.myGrid.getrows();
      this.NumberOfRecordings = data.length;
      CurrentPageJobslabel.text("Recording(s) displayed: " + this.NumberOfRecordings);
      pageSizelabel.text(1 + paginginfo.pagenum * paginginfo.pagesize + "-" + Math.min(parseInt(datainfo.rowscount || '0'), (paginginfo.pagenum + 1) * paginginfo.pagesize) + ' of ' + datainfo.rowscount);
      var datasource = [];
      for (var i = 1; i <= paginginfo.pagescount; i++) {
        datasource.push(i);
      }
      if (PageNumberGlobal == 1) {
        this.selectedDDLindex = 0;
      }
      if (paginginfo.pagescount > 6) {
        dropdown.jqxDropDownList({ source: datasource, selectedIndex: this.selectedDDLindex, dropDownVerticalAlignment: "top", theme: "material", width: 52, height: 28, scrollBarSize: 5 });
      }
      else {
        dropdown.jqxDropDownList({ source: datasource, selectedIndex: this.selectedDDLindex, dropDownVerticalAlignment: "top", theme: "material", width: 52, height: 28, autoDropDownHeight: true });
      }
      dropdown.on('select', (event: any) => {
        var args = event.args;
        if (args) {
          this.selectedDDLindex = args.index;
          if (args.index >= 0)
            PageNumberGlobal = args.item.label;
          this.myGrid.gotopage(args.index);
        }
      });
      // update buttons states.
      var leftbuttonresult = paginginfo.pagescount * paginginfo.pagenum;
      if (leftbuttonresult == 0) {
        leftButton.find('div').addClass("disabled");
      }
      else {
        leftButton.find('div').removeClass("disabled");
      }
      var rightbuttonresult = paginginfo.pagenum + 1;
      if (rightbuttonresult == paginginfo.pagescount) {
        rightButton.find('div').addClass("disabled");
      }
      else {
        rightButton.find('div').removeClass("disabled");
      }
      rightButton.click((event: any) => {

        if (rightbuttonresult < paginginfo.pagescount) {
          // go to next page.
          if (paginginfo.pagenum == 0) {
            PageNumberGlobal = 2;
          }
          else {
            PageNumberGlobal = parseInt(paginginfo.pagenum) + 2;
          }
          this.selectedDDLindex = this.selectedDDLindex + 1;
          this.myGrid.gotonextpage();
        }
      });
      leftButton.click((event: any) => {
        if (leftbuttonresult > 0) {
          // go to prev page.
          PageNumberGlobal = parseInt(paginginfo.pagenum);
          this.selectedDDLindex = this.selectedDDLindex - 1;
          this.myGrid.gotoprevpage();
        }
      });
      pageSizelabel.appendTo(this.element);
      dropdown.appendTo(this.element);
      leftButton.appendTo(this.element);
      rightButton.appendTo(this.element);
      CurrentPageJobslabel.appendTo(this.element);
      return this.element;
    }
    else {
      CurrentPageJobslabel.text("Job(s) displayed: " + 0);
      pageSizelabel.text(0 + "-" + 0 + ' of ' + 0);
      CurrentPageJobslabel.appendTo(this.element);
      return this.element;
    }
  }
  excelBtnOnClick() {
    var data = this.myGrid.getrows();
    var exportdata = [];
    for (var item of data) {
      const newitem = {
        // 'RecordingSessionId': item.recordingSessionId,
        'Case Number': item.caseNumber,
        'Organization Name': item.organizationName,
        'Department Name': item.departmentName,
        'Started': item.startedAt,
        'Language': item.language,
        'Status': item.status,
        'Courtroom': item.courtroom,
        'Court Location': item.courtLocation,
        'TranslateToEnglish': item.translateToEnglish,
        'Microphone': item.microphone,
        'RecordingSource': item.recordingSource,
        'SourceSystem': item.sourceSystem,
        'File Name': item.fileName,
      }
      exportdata.push(newitem);
    }
    this.excelService.exportAsExcelFile(exportdata, 'Recording-List');
    this.spinner.hide();
  };
  async getFile(url: string) {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    const res = await this.httpClient.get(url, httpOptions).toPromise().catch((err: HttpErrorResponse) => {
      const error = err.error;
      return error;
    });
    return res;
  }

  private async downloadPresignedFile(targetUrl: string, fileName: string): Promise<void> {
    try {
      const response = await fetch(targetUrl, {
        method: 'GET',
        credentials: 'omit',
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = objectUrl;
      link.download = fileName || 'recording.mp4';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
    } catch (error) {
      console.error('Presigned MP4 download failed:', error);
      this.sendNotification('Unable to download the recording file. Please try again.', 'error');
    }
  }

  getDatesByOption(DateValue: any) {
    let startdate;
    let endDate;
    var dateevent = new Date();
    this.updateCustomSearch(false);
    endDate = JSON.stringify(dateevent);
    endDate = endDate.slice(1, 11);
    DateValue = DateValue.replace(/['"]+/g, '');
    if (DateValue == "Today") {
      startdate = this.datePipe.transform(dateevent, 'yyyy-MM-dd');
      endDate = this.datePipe.transform(dateevent, 'yyyy-MM-dd');
    }
    if (DateValue == "Yesterday") {
      let aDate = new Date();
      aDate.setDate(aDate.getDate() - 1);
      startdate = this.datePipe.transform(aDate, 'yyyy-MM-dd');
      endDate = this.datePipe.transform(aDate, 'yyyy-MM-dd');
    }

    if (DateValue == "Last 7 days (six days ago to today)") {
      var startdateevent = dateevent.setDate(dateevent.getDate() - 6);
      startdate = new Date(startdateevent);
      startdate = JSON.stringify(startdate);
      startdate = startdate.slice(1, 11);
    }
    if (DateValue == "This week (Sunday to today)") {
      var dateNow = new Date();
      var dateToday = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
      var dateSunday = new Date(dateToday.getTime() - dateToday.getDay() * 24 * 3600 * 1000);
      var previousSunday = new Date(dateSunday);
      var startdateevent = previousSunday.setDate(previousSunday.getDate());
      var startdateevent = previousSunday.setDate(previousSunday.getDate() + 1);
      startdate = new Date(startdateevent);
      startdate = JSON.stringify(startdate);
      startdate = startdate.slice(1, 11);
    }
    if (DateValue == "This month (1st of this month to today)") {
      var dateNow = new Date();
      var firstDay = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1);
      var firstday = new Date(firstDay);
      var startdateevent = dateevent.setDate(firstday.getDate());
      startdate = new Date(startdateevent);
      startdate = JSON.stringify(startdate);
      startdate = startdate.slice(1, 11);
    }
    if (DateValue == "Last 31 days (30 days ago to today)") {
      var startdateevent = dateevent.setDate(dateevent.getDate() - 29);
      startdate = new Date(startdateevent);
      startdate = JSON.stringify(startdate);
      startdate = startdate.slice(1, 11);
    }
    if (DateValue == "Custom") {
      this.customSearch = true;
      var startdateevent = dateevent.setDate(dateevent.getDate());
      startdate = new Date(startdateevent);
      this.startmax = new Date(startdateevent);
      /////endmin
      var todayDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      startdate = this.datePipe.transform(todayDate, 'yyyy-MM-dd');
      endDate = this.datePipe.transform(todayDate, 'yyyy-MM-dd');
      this.startmax = new Date();
      this.endmax = new Date()
      this.updateCustomSearch(true);
      startdate = this.selectedStartDate == "" ? todayDate : this.datePipe.transform(this.selectedStartDate, 'yyyy-MM-dd');
      endDate = this.selectedEndDate == "" ? this.datePipe.transform(this.endmax, 'yyyy-MM-dd') : this.datePipe.transform(this.selectedEndDate, 'yyyy-MM-dd');
    }
    this.selectedStartDate = startdate;
    this.selectedEndDate = endDate;
  };

  updateCustomSearch(statusbar: any) {
    if (statusbar) {
      customStartDateContainer.style.display = "block";
      customEndDateContainer.style.display = "block";
      $('#customsearchButton').show();
    }
    else {
      customStartDateContainer.style.display = "none";
      customEndDateContainer.style.display = "none";
      $('#customsearchButton').hide();
    }
  }

  onDateOptionChange(event: any): void {
    this.spinner.show();
    if (this.selectedDateOption == "Custom") {
      this.DisplayCustomStartDate = new Date();
      this.DisplayCustomEnddate = new Date();
    }
    this.selectedStartDate = '';
    this.selectedEndDate = '';
    PageNumberGlobal = 1;
    this.customSearch = false;
    this.selectedDateOption = event.args.item.value;
    this.getJobsByStatus(JSON.stringify(this.selectedDateOption));
  };
  onStatusChange(event: any): void {
    PageNumberGlobal = 1;
    this.myGrid.clearselection();
    console.log("event:::", event);


    this.statusValue = event.args.item.value;
    this.getShowstatus(this.selectedStatusOption);
  };
  onRecorcingSourceChange(event: any): void {
    PageNumberGlobal = 1;
    this.myGrid.clearselection();
    console.log("event:::", event);
    this.sourceValue = event.args.item.value;
    this.getShowstatus(this.selectedStatusOption);
  };
  getPageData() {
    this.getShowstatus(this.selectedStatusOption);
  };
  getShowstatus(value: any) {
    this.getsqlData(this.selectedStartDate, this.selectedEndDate, this.statusValue, this.sourceValue, this.selectedOrgExtId, this.selectedDepartmentExtId);
  }
  getJobsByStatus(value: any) {
    this.hidestatus = value;
    this.getDatesByOption(JSON.stringify(this.selectedDateOption));
    this.getsqlData(this.selectedStartDate, this.selectedEndDate, this.statusValue, this.sourceValue, this.selectedOrgExtId, this.selectedDepartmentExtId);
    this.myGrid.updatebounddata();
  }

  counter: number = 1;
  tooltiprenderer = (element: any): void => {
    let id = `toolTipContainer${this.counter}`;
    element[0].id = id;
    let content = element[0].innerHTML;
    this.counter++;
  }

  visibilityrenderer = (row: any, columnfield: any, value: any, defaulthtml: any, columnproperties: any, rowdata: any, htmlElement: any) => {
    if (value == true) {
      return '<i class="material-icons" style="cursor:pointer">visibility</i>';
    }
    else {
      return '<i class="material-icons" style="cursor:pointer">visibility_off</i>';
    }
  };

  ChooseBoolItems: any[] = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" }
  ];
  recorcingSources: any[] =
    [
      { label: 'All', value: 'All' },
      { label: 'Web', value: 'Web' },
      { label: 'Desktop', value: 'Desktop' },
    ];
  status: any[] =
    [
      { label: 'All', value: 'All' },
      { label: 'Started', value: 'Started' },
      { label: 'Active', value: 'Active' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Failed', value: 'Failed' },
      { label: 'Paused', value: 'Paused' },
    ];

  labelRecordingGridFilters = (): void => {
    const grid = document.getElementById('recordings-grid');
    if (!grid) {
      return;
    }

    grid.querySelectorAll<HTMLInputElement>('.jqx-filter-input').forEach(input => {
      if (!input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
        input.setAttribute('aria-label', 'Filter recordings');
      }
    });
  };

  columns: any[] =
    [
      { text: 'Reference Number', datafield: 'caseNumber', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Organization Name', datafield: 'organizationName', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Department Name', datafield: 'departmentName', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Judge First Name', datafield: 'judgeFirstName', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Judge Last Name', datafield: 'judgeLastName', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Hearing Date Time', datafield: 'hearingDateTime', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Started At', datafield: 'startedAt', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Host Name', datafield: 'hostName', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Language', datafield: 'language', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Status', datafield: 'status', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'File Name', datafield: 'roomName', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Output Path', datafield: 'outputPath', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Created Date', datafield: 'createdAt', width: '15%', filterable: false, align: 'center' },
      { text: 'Court Room', datafield: 'courtroom', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Court Location', datafield: 'courtLocation', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Translate to English', datafield: 'translateToEnglish', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Microphone', datafield: 'microphone', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Recording Source', datafield: 'recordingSource', width: '10%', filtertype: 'input', align: 'center' },
      { text: 'Source System', datafield: 'sourceSystem', filtertype: 'input', width: '12%', align: 'center' },
      { text: 'Download Status', datafield: 'downloadStatus', filtertype: 'input', width: '12%', align: 'center' },
    ];


  rendergridrows = (params: any): any => {
    return params.data;
  }
  ///////////////////////buttons creation///////////////
  createButtonsContainers(statusbar: any): void {

    if (statusbar[0] == null || statusbar[0] == 'undefined') {
    }
    else {
      let buttonsContainer = document.createElement('div');
      buttonsContainer.style.cssText = 'overflow: hidden; position: fixed; margin: 5px; border-color: none; background: none; width: 90%';

      let RemoveSelectionContainer = document.createElement('div');
      RemoveSelectionContainer.id = 'RemoveButton';
      RemoveSelectionContainer.className = 'panelButtonclass';
      RemoveSelectionContainer.style.cssText = 'float: left; margin-left: 5px;';

      let datepickerButtonContainer = document.createElement('div');
      datepickerButtonContainer.id = "datepickerButton";
      datepickerButtonContainer.className = 'panelButtonclass';
      datepickerButtonContainer.style.cssText = 'theme: material; float: right; margin-left: 5px;';

      customStartDateContainer = document.createElement('div');
      customEndDateContainer = document.createElement('div');
      customsearchButtonContainer = document.createElement('div');

      customStartDateContainer.id = "customstartdate"
      customEndDateContainer.id = "customenddate"
      customsearchButtonContainer.id = 'customsearchButton';


      customStartDateContainer.style.cssText = 'theme: material;float: right; margin-left: 5px;';
      customEndDateContainer.style.cssText = 'theme: material;float: right; margin-left: 5px;';
      customsearchButtonContainer.style.cssText = 'theme: material;float: right; margin-left: 5px;';

      customsearchButtonContainer.style.display = "none";
      customStartDateContainer.style.display = "none";
      customEndDateContainer.style.display = "none";

      let refreshContainerRecordingList = document.createElement('div');
      refreshContainerRecordingList.id = 'refreshButton';
      refreshContainerRecordingList.className = 'panelButtonclass';
      refreshContainerRecordingList.style.cssText = 'float: left; margin-left: 5px;';

      let exportContainerRecordingList = document.createElement('div');
      exportContainerRecordingList.id = 'exportButton';
      exportContainerRecordingList.className = 'panelButtonclass';
      exportContainerRecordingList.style.cssText = 'float: left; margin-left: 5px;';

      let requestForDownloadContainer = document.createElement('div');
      requestForDownloadContainer.id = 'requestForDownloadButton';
      requestForDownloadContainer.className = 'panelButtonclass';
      requestForDownloadContainer.style.cssText = 'float: left; margin-left: 5px;';

      let downloadContainerRecordingList = document.createElement('div');
      downloadContainerRecordingList.id = 'downloadButton';
      downloadContainerRecordingList.className = 'panelButtonclass';
      downloadContainerRecordingList.style.cssText = 'float: left; margin-left: 5px;';

      // let createRecordingButtonContainer = document.createElement('div');
      // createRecordingButtonContainer.id = 'createRecordingButton';
      // createRecordingButtonContainer.className = 'panelButtonclass';
      // createRecordingButtonContainer.style.cssText = 'float: left; margin-right: 5px; margin-left: 5px;';

      let viewRecordingDetailsContainer = document.createElement('div');
      viewRecordingDetailsContainer.id = 'viewRecordingDetailsButton';
      viewRecordingDetailsContainer.className = 'panelButtonclass';
      viewRecordingDetailsContainer.style.cssText = 'float: left; margin-right: 5px; margin-left: 5px;';

      //buttonsContainer.appendChild(createRecordingButtonContainer);
      buttonsContainer.appendChild(viewRecordingDetailsContainer);
      buttonsContainer.appendChild(RemoveSelectionContainer);
      buttonsContainer.appendChild(refreshContainerRecordingList);
      buttonsContainer.appendChild(exportContainerRecordingList);
      buttonsContainer.appendChild(requestForDownloadContainer);
      buttonsContainer.appendChild(downloadContainerRecordingList);

      statusbar[0].appendChild(buttonsContainer);
    }
  }
  initializeTooltip(selector: any, content: any) {
    const button = $(selector);
    button.attr('aria-label', content);
    button.find('img[src=""]:not([alt])').attr({ alt: '', 'aria-hidden': 'true' });
    tippy(selector, {
      content: content,
      arrow: true,
      placement: 'top', // Adjust as needed
    });
  }

  private getSelectedGridRow(): any | null {
    const selectedIndexes = this.myGrid?.getselectedrowindexes?.() || [];
    if (!selectedIndexes || selectedIndexes.length === 0) {
      return null;
    }
    return this.myGrid.getrowdata(selectedIndexes[0]);
  }

  private updateDownloadActionButtonState(): void {
    const selectedRow = this.getSelectedGridRow();
    const downloadStatus = selectedRow && selectedRow.downloadStatus !== undefined && selectedRow.downloadStatus !== null
      ? String(selectedRow.downloadStatus).trim().toUpperCase()
      : '';

    const requestButton = $('#requestForDownloadButton');
    const downloadButton = $('#downloadButton');

    if (!requestButton.length || !downloadButton.length) {
      return;
    }

    const isRequested = downloadStatus === 'REQUESTED';
    const shouldShowRequest = !!selectedRow && !downloadStatus;
    const shouldShowDownload = !selectedRow || downloadStatus === 'READY' || isRequested;

    requestButton.toggle(shouldShowRequest);
    downloadButton.toggle(shouldShowDownload);

    downloadButton.prop('disabled', isRequested);
    downloadButton.attr('aria-disabled', String(isRequested));
    downloadButton.css({
      opacity: isRequested ? '0.5' : '1',
      cursor: isRequested ? 'not-allowed' : 'pointer'
    });
  }

  onRowSelect(event: any): void {
    this.updateDownloadActionButtonState();
  }

  onRowUnselect(event: any): void {
    this.updateDownloadActionButtonState();
  }

  createButtons(): void {

    
    //////////////view Details
    let viewDetailsButtonOptions = {
      width: 40, height: 25, value: '<img src="../../../assets/img/icon/form.png" alt="Form Data" class="user-listicon"/>',
    }
    let viewDetailsButton = jqwidgets.createInstance('#viewRecordingDetailsButton', 'jqxButton', viewDetailsButtonOptions);
    this.initializeTooltip('#viewRecordingDetailsButton', 'View Details');
    viewDetailsButton.addEventHandler('click', (event: any): void => {
      this.recordingIndex = this.myGrid.getselectedrowindexes();
      if (this.recordingIndex.length == 1) {
        const rowData = this.myGrid.getrowdata(this.recordingIndex[0]);
        this.openRecordingInfo(rowData);

      }
      else {
        this.sendNotification("Please select one recording to get details.", "error");
      }


    });

    //////////////remove selection button
    let removeSelectionButtonOptions = {
      width: 40, height: 25, value: '<img src="../../../assets/img/icon/clear.png" alt="Clear"  class="user-listicon"/>'//'<i class="material-icons" title = "Clear selection" style="cursor:pointer">remove_circle</i>',
    }
    let removeSelectionButton = jqwidgets.createInstance('#RemoveButton', 'jqxButton', removeSelectionButtonOptions);
    this.initializeTooltip('#RemoveButton', 'Clear Selection');
    removeSelectionButton.addEventHandler('click', (event: any): void => {
      this.recordingindex = [];
      this.recordingindex = this.myGrid.getselectedrowindexes();
      if (this.recordingindex.length > 0) {
        this.removeSelectedRows();
      }
      else {
        this.sendNotification("No Recording is selected. Please select a valid Recording.", "error");
      }
    });

    let refreshButtonOptions = {
      width: 40, height: 25, value: '<img src="../../../assets/img/icon/refresh.png" alt="Refresh"  class="user-listicon"/>',
      imgPosition: 'center', theme: 'material', textPosition: 'center', template: 'link'
    }
    let refreshButton = jqwidgets.createInstance('#refreshButton', 'jqxButton', refreshButtonOptions);
    this.initializeTooltip('#refreshButton', 'Refresh Recording List');
    refreshButton.addEventHandler('click', (event: any): void => {
      this.refreshGrid();
    });

    let exportButtonOptions = {
      width: 40, height: 25, value: '<img src="../../../assets/img/icon/export.png" alt="Export"  class="user-listicon"/>',
      imgPosition: 'center', theme: 'material', textPosition: 'center', template: 'link'
    }
    let exportButton = jqwidgets.createInstance('#exportButton', 'jqxButton', exportButtonOptions);
    this.initializeTooltip('#exportButton', 'Export Recording List');
    exportButton.addEventHandler('click', (event: any): void => {
      this.spinner.show();
      const rows = this.myGrid.getrows();
      if (rows.length > 0) {
        // Get the browser's time zone offset in minutes
        this.excelBtnOnClick();
      } else {
        this.sendNotification("No records found", 'error');
        this.spinner.hide();
      }
    });

    let requestForDownloadButtonOptions = {
      width: 40,
      height: 25,
      value: '<img src="../../../assets/img/icon/request-for-download.png" alt="Request For Download" title="Request For Download" class="user-listicon"/>',
      imgPosition: 'center',
      theme: 'material',
      textPosition: 'center',
      template: 'link'
    };
    let requestForDownloadButton = jqwidgets.createInstance('#requestForDownloadButton', 'jqxButton', requestForDownloadButtonOptions);
    this.initializeTooltip('#requestForDownloadButton', 'Request For Download');
    requestForDownloadButton.addEventHandler('click', (event: any): void => {
      const selectedRow = this.getSelectedGridRow();
      if (!selectedRow || !selectedRow.id) {
        this.sendNotification('Please select a recording before requesting download.', 'error');
        return;
      }

      this.spinner.show();
      this.backendService.RequestForDownload(selectedRow.id).subscribe({
        next: () => {
          this.spinner.hide();
          this.refreshGrid();
          this.sendNotification('Request For Download submitted for the selected recording.', 'success');
        },
        error: (err: any) => {
          this.spinner.hide();
          console.error('RequestForDownload failed:', err);
          this.sendNotification('Unable to submit Request For Download for the selected recording.', 'error');
        }
      });
    });

    let downloadButtonOptions = {
      width: 40,
      height: 25,
      value: '<img src="../../../assets/img/icon/download-recording.png" alt="Download" title="Download" class="user-listicon"/>',
      imgPosition: 'center',
      theme: 'material',
      textPosition: 'center',
      template: 'link'
    };
    let downloadButton = jqwidgets.createInstance('#downloadButton', 'jqxButton', downloadButtonOptions);
    this.initializeTooltip('#downloadButton', 'Download');
    downloadButton.addEventHandler('click', async (event: any): Promise<void> => {
      const selectedRow = this.getSelectedGridRow();
      if (!selectedRow) {
        this.sendNotification('Please select a recording to download.', 'error');
        return;
      }

      const normalizedStatus = String(selectedRow.downloadStatus || '').trim().toUpperCase();
      if (normalizedStatus === 'REQUESTED') {
        this.sendNotification('This recording download is already requested and is pending.', 'warning');
        return;
      }

      if (normalizedStatus !== 'READY') {
        this.sendNotification('This recording is not ready for download yet.', 'warning');
        return;
      }

      this.spinner.show();

      try {
        console.log('💾 Download Audio/Video file ', selectedRow.roomName);
        const payload: GetFileUploadModel = {
          fileName: selectedRow.roomName + ".mp4",
          contentType: "video/mp4",
          roomName: selectedRow.roomName,
          fileType: "MediaFile"
        };

        const response: any = await this.backendService.getFileDownloadURL(payload).toPromise();
        // console.log('💾  Download result', response);
        const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;

        if (parsedResponse && parsedResponse.success && parsedResponse.data?.presignedUrl) {
          const targetUrl = parsedResponse.data.presignedUrl;
          const fileName = (selectedRow.roomName || 'recording') + '.mp4';
          await this.downloadPresignedFile(targetUrl, fileName);
          this.sendNotification('Download started for the selected recording.', 'success');
          return;
        }

        this.sendNotification('No downloadable file URL was returned for the selected recording.', 'error');
      } catch (error) {
        console.error('Recording MP4 download failed:', error);
        this.sendNotification('Unable to download the recording file.', 'error');
      } finally {
        this.spinner.hide();
      }
    });

    this.updateDownloadActionButtonState();

    // let editDocumentButtonOptions = {
    //   width: 40, height: 25, value: '<img src="../../../assets/img/icon/edit-document.png" alt="Edit Document" class="user-listicon"/>',
    //   imgPosition: 'center', theme: 'material', textPosition: 'center', template: 'link'
    // }
    // let editDocumentButton = jqwidgets.createInstance('#editDocumentButton', 'jqxButton', editDocumentButtonOptions);
    // this.initializeTooltip('#editDocumentButton', 'View Document');
    // editDocumentButton.addEventHandler('click', async (event: any) => {
    //   this.IsAudioPlay = false;
    //   this.orderindex = [];
    //   this.orderindex = this.myGrid.getselectedrowindexes();
    //   //Need to implement 
    // });
  }
  openRecordingInfo(rowData: any) {
    if (rowData && !Array.isArray(rowData.caseDetails)) {
      // Grid bound data drops unmapped fields, so re-attach the cases captured from the API response.
      rowData.caseDetails = this.caseDetailsByRecordingId.get(rowData.id) || [];
    }

    if (this.isDetailWindowMode) {
      this.loadRecordingInfoData(rowData);
      return;
    }

    this.openRecordingDetailsWindow(rowData);
  }

  private openRecordingDetailsWindow(rowData: any): void {
    if (!rowData) {
      this.safeNotify('Unable to open recording details for the selected row.', 'error');
      return;
    }

    // One token (and one popup) per recording, so reopening reuses the stored row and the open window.
    const token = rowData.id
      ? `${rowData.id}`
      : `recording-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const storageKey = this.getDetailStorageKey(token);
    this.purgeStaleDetailPayloads();

    const alreadyStored = localStorage.getItem(storageKey) !== null;
    if (!alreadyStored) {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), rowData }));
      } catch (error) {
        console.error('Failed to store recording details for new window', error);
        this.safeNotify('Unable to open details in a new window.', 'error');
        return;
      }
    }

    const tree = this.router.createUrlTree(['/admin/netscribeliveList'], {
      queryParams: {
        detailWindow: 1,
        detailToken: token
      }
    });
    const detailUrl = this.router.serializeUrl(tree);

    // Opening with an empty URL returns the existing named window without reloading it.
    const popup = window.open(
      '',
      `recording-detail-${token}`,
      'width=1500,height=900,left=120,top=25,resizable=yes,scrollbars=yes'
    );

    if (!popup) {
      this.safeNotify('Popup blocked by browser. Please allow popups and try again.', 'error');
      if (!alreadyStored) {
        localStorage.removeItem(storageKey);
      }
      return;
    }

    let isAlreadyOpen = false;
    try {
      isAlreadyOpen = popup.location.href !== 'about:blank';
    } catch {
      isAlreadyOpen = true;
    }

    if (!isAlreadyOpen) {
      popup.location.href = detailUrl;
    }
    popup.focus();
  }

  private loadDetailWindowRecording(): void {
    if (!this.detailWindowToken) {
      console.warn('Recording details token is missing for detail window mode.');
      return;
    }

    const storageKey = this.getDetailStorageKey(this.detailWindowToken);
    const rawPayload = localStorage.getItem(storageKey);
    if (!rawPayload) {
      console.warn('No recording details payload found for token', this.detailWindowToken);
      return;
    }

    try {
      const payload = JSON.parse(rawPayload);
      // Entries saved before savedAt was added hold the row directly.
      const rowData = payload && typeof payload.savedAt === 'number' ? payload.rowData : payload;
      this.loadRecordingInfoData(rowData);
    } catch (error) {
      console.error('Failed to parse recording details payload', error);
    }
  }

  // Payloads stay until expiry so refreshing a detail popup still works.
  private purgeStaleDetailPayloads(): void {
    const prefix = AudiostreamingListComponent.DETAIL_STORAGE_KEY_PREFIX;
    const cutoff = Date.now() - AudiostreamingListComponent.DETAIL_STORAGE_MAX_AGE_MS;
    const staleKeys: string[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(prefix)) {
        continue;
      }
      try {
        const savedAt = JSON.parse(localStorage.getItem(key) || 'null')?.savedAt;
        if (typeof savedAt !== 'number' || savedAt < cutoff) {
          staleKeys.push(key);
        }
      } catch {
        staleKeys.push(key);
      }
    }

    staleKeys.forEach(key => localStorage.removeItem(key));
  }

  private getDetailStorageKey(token: string): string {
    return `${AudiostreamingListComponent.DETAIL_STORAGE_KEY_PREFIX}${token}`;
  }

  private safeNotify(message: string, messageType: string): void {
    if (this.msgNotification?.elementRef?.nativeElement) {
      this.sendNotification(message, messageType);
      return;
    }

    console.log(`${messageType.toUpperCase()}: ${message}`);
  }

  formatFormDataValue(entry: FormDataEntry): string {
    if (entry.value === null || entry.value === undefined || entry.value === '') {
      return '-';
    }
    if (typeof entry.value === 'boolean') {
      return entry.value ? 'Yes' : 'No';
    }
    if (entry.type === FieldType.Date || entry.type === FieldType.DateTime) {
      const format = entry.type === FieldType.Date ? 'MMMM dd yyyy' : 'EEE MMMM dd yyyy HH:mm:ss';
      return this.datePipe.transform(entry.value as string, format) ?? String(entry.value);
    }
    return String(entry.value);
  }

  private loadRecordingInfoData(rowData: any): void {
    this.transcriptionText = "";
    this.selectedRecording = rowData;
    this.loadRecordingOrganizationIsCourt(rowData);
    this.HaveTranscription = !!(rowData?.transcriptionFilePath && String(rowData.transcriptionFilePath).trim() !== '');
    this.formDetails = parseFormDataSnapshot(rowData.formData);
    this.buildCaseDetailRows(rowData);
    //this.selectedRecording.duration = this.calculateDuration(rowData.startedAt, rowData.stoppedAt);
    this.selectedRecording.judgeName = rowData.judgeFirstName + " " + rowData.judgeLastName;
    const AudioDetails = JSON.parse(this.selectedRecording.recordingDetails ?? '{}');
    this.selectedRecording.startedAt = AudioDetails.AudioStart;
    this.selectedRecording.stoppedAt = AudioDetails.AudioEnd;
    this.selectedRecording.duration = this.calculateDuration(AudioDetails.AudioStart, AudioDetails.AudioEnd);
    // Pass an empty JSON string fallback if it is undefined
    this.parseRecordingTimelineData(this.selectedRecording.recordingDetails ?? '{}');
    //this.selectedRecording.autoStartTranscription = rowData.autoStartTranscription || false;
    this.selectedRecording.postRecordingAnnotationUpdate = rowData.postRecordingAnnotationUpdate || false;
    console.log("Selected Recording for details:", this.selectedRecording);
    //this.viewRecordingDetails.open();
    this.playHlsForRoom(rowData.roomName);
    if(rowData.transcriptionFilePath != null)
    {
    this.DownloadTranscriptionFromServer(rowData.roomName);
    //this.HaveTranscription = false;
    }
    else{
      console.log("Transcription file path is null, skipping download.");
    }
    this.processEvents(this.selectedRecording.recordingDetails ? this.selectedRecording.recordingDetails : '');
    this.calculateWindowSize();
    if (this.viewRecordingDetails) {
      this.viewRecordingDetails.setOptions({
        width: this.windowWidth,
        height: this.windowHeight
      });
      if (this.isDetailWindowMode) {
        this.viewRecordingDetails.move(20, 20);
      }
      this.viewRecordingDetails.open();
    }
    // Ensure Angular picks up changes made during AfterViewInit / async flows
    try {
      this.cdRef.detectChanges();
    } catch (e) {
      // ignore detection errors — presence of this call reduces ExpressionChangedAfterItHasBeenCheckedError
      console.debug('detectChanges() call in loadRecordingInfoData caught:', e);
    }
  }
  onSummaryWindowClose(): void {
    this.selectedPromptId = -1;
    this.summaryPrompt = '';
    this.customPromptText = '';
    this.summaryText = '';
  }

  private loadRecordingOrganizationIsCourt(recording: any): void {
    this.selectedRecordingIsCourt = recording?.isCourt === true;
    if (typeof recording?.isCourt === 'boolean' || !recording?.orgExtId) {
      return;
    }

    this.backendService.getOrganizationByExtId(recording.orgExtId).subscribe({
      next: (response: any) => {
        if (this.selectedRecording === recording) {
          const organization = this.backendService.getJSONResponse(response)?.data;
          this.selectedRecordingIsCourt = organization?.isCourt === true;
        }
      },
      error: () => {
        if (this.selectedRecording === recording) {
          this.selectedRecordingIsCourt = false;
        }
      }
    });
  }

  private buildCaseDetailRows(rowData: any): void {
    this.selectedCaseDetail = null;
    this.caseFilteredTranscriptionHtml = null;
    this.caseWindowStart = 0;
    this.caseWindowEnd = null;
    this.isCaseDetailsPanelExpanded = true;

    const cases = Array.isArray(rowData?.caseDetails) ? rowData.caseDetails : [];
    const timeline = typeof rowData?.recordingDetails === 'string'
      ? JSON.parse(rowData.recordingDetails || '{}')
      : (rowData?.recordingDetails || {});
    const audioStart = this.toUtcDate(timeline.AudioStart);
    const audioEnd = this.toUtcDate(timeline.AudioEnd);
    this.caseDetailRows = cases
      .map((item: any) => {
        const startedAt = this.toUtcDate(item.startedAt);
        const stoppedAt = this.toUtcDate(item.stoppedAt);
        return {
          id: item.id,
          caseNumber: item.caseNumber || '-',
          judgeName: (item.judgeName || '').trim() || '-',
          hearingDateTime: this.toUtcDate(item.hearingDateTime),
          startedAt,
          stoppedAt,
          durationText: this.resolveCaseDuration(item.duration, startedAt, stoppedAt),
          formEntries: parseFormDataSnapshot(item.formData)
        } as CaseDetailRow;
      })
      .sort((a: CaseDetailRow, b: CaseDetailRow) =>
        (a.startedAt ? a.startedAt.getTime() : 0) - (b.startedAt ? b.startedAt.getTime() : 0))
      .map((row: CaseDetailRow, index: number, rows: CaseDetailRow[]) => {
        const startedAt = index === 0 && audioStart ? audioStart : row.startedAt;
        const stoppedAt = index === rows.length - 1 && audioEnd ? audioEnd : row.stoppedAt;
        const durationText = audioStart && startedAt && stoppedAt
          ? this.formatTime(this.getCaseRecordedSeconds(startedAt, stoppedAt, timeline.Events))
          : row.durationText;
        return { ...row, hearingDateTime: row.hearingDateTime || startedAt, startedAt, stoppedAt, durationText };
      });
    this.refreshAnnotationSpeakers();
  }

  private refreshAnnotationSpeakers(): void {
    const entries = this.selectedCaseDetail?.formEntries ?? this.formDetails;
    this.annotationSpeakers = buildAnnotationSpeakers(entries, entry => entry.value);
  }

  private getCaseRecordedSeconds(startedAt: Date, stoppedAt: Date, events: any): number {
    const start = startedAt.getTime();
    const end = stoppedAt.getTime();
    let pausedAt: number | null = null;
    let pausedMs = 0;
    const timelineEvents = (Array.isArray(events) ? events : [])
      .map(event => ({ action: event.Action, time: this.toUtcDate(event.Time)?.getTime() }))
      .filter(event => event.time !== undefined)
      .sort((first, second) => first.time! - second.time!);

    for (const event of timelineEvents) {
      if (event.action === 'Paused' && pausedAt === null) {
        pausedAt = event.time!;
      } else if (event.action === 'Resumed' && pausedAt !== null) {
        pausedMs += Math.max(0, Math.min(end, event.time!) - Math.max(start, pausedAt));
        pausedAt = null;
      }
    }
    if (pausedAt !== null) {
      pausedMs += Math.max(0, end - Math.max(start, pausedAt));
    }
    return Math.max(0, end - start - pausedMs) / 1000;
  }

  private toUtcDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const raw = String(value);
    // API returns UTC timestamps without a zone designator.
    const normalized = raw.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(raw) ? raw : `${raw}Z`;
    const parsed = new Date(normalized);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private resolveCaseDuration(durationSeconds: any, startedAt: Date | null, stoppedAt: Date | null): string {
    if (typeof durationSeconds === 'number' && durationSeconds > 0) {
      return this.formatTime(durationSeconds);
    }
    if (startedAt && stoppedAt) {
      return this.formatTime((stoppedAt.getTime() - startedAt.getTime()) / 1000);
    }
    return '--:--:--';
  }

  selectCaseDetail(caseRow: CaseDetailRow): void {
    this.selectedCaseDetail = caseRow;
    this.refreshAnnotationSpeakers();
    this.applyCaseTranscriptionFilter(caseRow);
    this.applyCaseAudioWindow(caseRow);
  }

  clearCaseSelection(): void {
    this.selectedCaseDetail = null;
    this.caseFilteredTranscriptionHtml = null;
    this.caseWindowStart = 0;
    this.caseWindowEnd = null;
    this.refreshAnnotationSpeakers();
  }

  // Playback is limited to the selected case window, otherwise the whole recording.
  get playbackStart(): number {
    return this.selectedCaseDetail ? this.caseWindowStart : 0;
  }

  get playbackEnd(): number {
    return this.selectedCaseDetail && this.caseWindowEnd !== null
      ? this.caseWindowEnd
      : (this.audioDuration || 0);
  }

  get playbackDuration(): number {
    return Math.max(0, this.playbackEnd - this.playbackStart);
  }

  get playbackStartDate(): Date {
    return this.getRealTimestampForVirtualTime(this.playbackStart);
  }

  get playbackEndDate(): Date {
    const stoppedAt = this.selectedCaseDetail?.stoppedAt || this.toUtcDate(this.selectedRecording?.stoppedAt);
    return stoppedAt || this.getRealTimestampForVirtualTime(this.playbackEnd);
  }

  private applyCaseAudioWindow(caseRow: CaseDetailRow): void {
    this.caseWindowStart = 0;
    this.caseWindowEnd = null;

    const audioStartMs = this.selectedRecording?.startedAt
      ? new Date(this.selectedRecording.startedAt).getTime()
      : NaN;
    if (!caseRow?.startedAt || isNaN(audioStartMs)) {
      return;
    }

    const totalDuration = this.audioDuration || 0;
    const startOffset = Math.max(0, (caseRow.startedAt.getTime() - audioStartMs) / 1000);
    this.caseWindowStart = Math.min(Math.max(this.mapRealToVirtual(startOffset).virtualTime, 0), totalDuration);

    if (caseRow.stoppedAt) {
      const endOffset = Math.max(0, (caseRow.stoppedAt.getTime() - audioStartMs) / 1000);
      const windowEnd = Math.min(Math.max(this.mapRealToVirtual(endOffset).virtualTime, 0), totalDuration);
      this.caseWindowEnd = windowEnd > this.caseWindowStart ? windowEnd : totalDuration;
    } else {
      this.caseWindowEnd = totalDuration;
    }

    this.seekTo(this.caseWindowStart);
  }

  private applyCaseTranscriptionFilter(caseRow: CaseDetailRow | null): void {
    const html = this.editableTranscriptionContent;
    if (!caseRow || !caseRow.startedAt || !html) {
      this.caseFilteredTranscriptionHtml = null;
      return;
    }

    const caseStartMs = caseRow.startedAt.getTime();
    const caseEndMs = caseRow.stoppedAt ? caseRow.stoppedAt.getTime() : Number.MAX_SAFE_INTEGER;

    const container = document.createElement('div');
    container.innerHTML = html;
    const segments = this.getCaseTranscriptionSegments(container);

    if (segments.length === 0) {
      this.caseFilteredTranscriptionHtml = null;
      return;
    }

    this.caseFilteredTranscriptionHtml = segments
      .filter(segment => segment.endMs >= caseStartMs && segment.startMs <= caseEndMs)
      .map(segment => segment.html)
      .join('');
  }

  private getCaseTranscriptionSegments(container: HTMLElement): CaseTranscriptionSegment[] {
    const segments: CaseTranscriptionSegment[] = [];
    let currentSegment: CaseTranscriptionSegment | null = null;

    Array.from(container.children).forEach(child => {
      const element = child as HTMLElement;
      const segmentStartCount = this.countSegmentStartElements(element);

      if (segmentStartCount > 1) {
        segments.push(...this.getCaseTranscriptionSegments(element));
        currentSegment = null;
        return;
      }

      if (segmentStartCount === 1) {
        const startElement = this.findSegmentStartElement(element) || element;
        const range = this.extractSegmentTimeRange(startElement.textContent || '');
        if (range) {
          currentSegment = { startMs: range.startMs, endMs: range.endMs, html: element.outerHTML };
          segments.push(currentSegment);
        }
        return;
      }

      if (currentSegment) {
        currentSegment.html += element.outerHTML;
      }
    });

    return segments;
  }

  private countSegmentStartElements(element: HTMLElement): number {
    let count = this.isSegmentStartElement(element) ? 1 : 0;
    (Array.from(element.querySelectorAll('p, div, li')) as HTMLElement[])
      .forEach(child => {
        if (this.isSegmentStartElement(child)) {
          count++;
        }
      });
    return count;
  }

  private findSegmentStartElement(element: HTMLElement): HTMLElement | null {
    if (this.isSegmentStartElement(element)) {
      return element;
    }
    return (Array.from(element.querySelectorAll('p, div, li')) as HTMLElement[])
      .find(child => this.isSegmentStartElement(child)) || null;
  }

  private isSegmentStartElement(element: HTMLElement): boolean {
    if (!this.extractSegmentTimeRange(element.textContent || '')) {
      return false;
    }

    return !(Array.from(element.querySelectorAll('p, div, li')) as HTMLElement[])
      .some(child => !!this.extractSegmentTimeRange(child.textContent || ''));
  }

  private extractSegmentTimeRange(text: string): { startMs: number; endMs: number } | null {
    const match = text.match(AudiostreamingListComponent.SEGMENT_TIME_PATTERN);
    if (!match) {
      return null;
    }
    const startMs = new Date(match[1].replace(' ', 'T')).getTime();
    const endMs = new Date(match[2].replace(' ', 'T')).getTime();
    if (isNaN(startMs) || isNaN(endMs)) {
      return null;
    }
    return { startMs, endMs };
  }
  
  downloadSummary(): void {
    if (!this.summaryText || this.summaryText.trim() === '') {
      this.sendNotification('No summary available to download.', 'error');
      return;
    }

    const idForFile = (this.selectedRecording && (this.selectedRecording as any).id) ? (this.selectedRecording as any).id : 0;
    try {
      this.excelService.downloadAsDocx(this.summaryText, idForFile);
      this.sendNotification('Summary download started.', 'success');
    } catch (err) {
      console.error('downloadSummary failed', err);
      this.sendNotification('Failed to generate summary file.', 'error');
    }
  }

  copyToClipboard(): void {
    const textToCopy = this.summaryText || '';

    if (!textToCopy) {
      this.sendNotification('No summary available to copy.', 'error');
      return;
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.sendNotification('Text copied to clipboard!', 'success');
      }).catch(err => {
        console.error('Clipboard write failed:', err);
        this.sendNotification('Copy failed.', 'error');
      });
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.sendNotification('Text copied using fallback!', 'success');
      } catch (err) {
        console.error('Fallback copy failed:', err);
        this.sendNotification('Copy failed.', 'error');
      }
      document.body.removeChild(textarea);
    }
  }
  //rawJsonString = "{\"Events\": [{\"Time\": \"2026-05-19T08:21:21.375Z\", \"Action\": \"Paused\"}, {\"Time\": \"2026-05-19T08:21:32.826Z\", \"Action\": \"Resumed\"}, {\"Time\": \"2026-05-19T08:21:49.399Z\", \"Action\": \"Paused\"}, {\"Time\": \"2026-05-19T08:22:01.558Z\", \"Action\": \"Resumed\"}], \"AudioEnd\": \"2026-05-19T08:22:09.634Z\", \"AudioStart\": \"2026-05-19T08:20:42.581Z\"}";
  private calculateWindowSize(): void {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Use 80% of screen width and 70% of screen height
    this.windowWidth = Math.round(screenWidth * 0.9);
    this.windowHeight = Math.round(screenHeight * 0.9);
  }
  parseRecordingTimelineData(rawJsonString: string) {
    try {
      this.parsedTimelineData = JSON.parse(rawJsonString);
      if (this.parsedTimelineData && this.parsedTimelineData.Events) {
        this.timelineEvents = this.parsedTimelineData.Events;
        console.log("timelineEvents... ", this.timelineEvents);
      }
    } catch (e) {
      console.error("Error parsing recording details json string", e);
    }
  }

  // Generates timestamps dynamically between step streams
  calculateDuration(startTimeStr: string, endTimeStr: string): string {
    const start = new Date(startTimeStr).getTime();
    const end = new Date(endTimeStr).getTime();
    const diffMs = end - start;

    if (diffMs <= 0) return '00:00:00';

    const secs = Math.floor((diffMs / 1000) % 60);
    const mins = Math.floor((diffMs / (1000 * 60)) % 60);
    const hours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);

    return [
      hours.toString().padStart(2, '0'),
      mins.toString().padStart(2, '0'),
      secs.toString().padStart(2, '0')
    ].join(':');
  }
  // skipAudio(seconds: number): void {
  //   const audioElement = this.audioRef?.nativeElement;
  //   if (!audioElement) return;

  //   // Calculate the new target timestamp
  //   let newTime = audioElement.currentTime + seconds;

  //   // Prevent skipping below 0 seconds
  //   if (newTime < 0) {
  //     newTime = 0;
  //   }

  //   // Prevent skipping past the total audio duration
  //   if (this.audioDuration && newTime > this.audioDuration) {
  //     newTime = this.audioDuration;
  //   }

  //   // Update the HTML5 audio element current time position
  //   audioElement.currentTime = newTime;

  //   // Update your tracking variable for the UI timestamp display instantly
  //   this.audioCurrentTime = newTime;

  //   // Optional: Recalculate progress percentage immediately for smooth UI updates
  //   if (this.audioDuration) {
  //     this.audioProgressPercent = (this.audioCurrentTime / this.audioDuration) * 100;
  //   }
  // }
  skipAudio(seconds: number): void {
    const targetVirtualTime = Math.max(this.playbackStart, Math.min(this.playbackEnd, this.audioCurrentTime + seconds));
    this.seekTo(targetVirtualTime);
  }
  async audioDownload() {
    this.spinner.show();
    this.recordingindex.forEach(async element => {
      var row = this.myGrid.getrowdata(element);
      const downloadAudioData = this.getJSONResponse(await this.backendService.getAudioDownloadURLByJobId("", row.id, false).toPromise());
      if ((downloadAudioData.data.audioDownloadUrls.length == 0) && (downloadAudioData.data.audioFileNames.length == 0)) {
        this.sendNotification('This Recording does not have any audio files to download.', 'error');
        this.spinner.hide();
      }
      else {
        for (let i = 0; i < downloadAudioData.data.audioDownloadUrls.length; i++) {
          let url = downloadAudioData.data.audioDownloadUrls[i];
          let filename = downloadAudioData.data.audioFileNames[i];
          this.fileDownloadLoop(url, filename, true);
        }
      }

    });
  }
  async fileDownloadLoop(url: any, fileName: any, IsProgress: any) {
    this.spinner.show();
    (await this.fileaccess.downloadWithProgress(url, fileName, IsProgress)).subscribe({
      next: (event: any) => {
        if (event.type === 'progress') {
          this.progress = event.value;
        } else if (event.type === 'response') {
          this.spinner.hide();
          this.progress = 0
          this.sendNotification(fileName + ' - File Downloaded successfully.', 'success');
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
        this.sendNotification('Downloded failed.', 'error');
      }
    });
  }

  setRecordingsListString() {
    // this.usernameslist = "";
    this.recordingindex = [];
    this.recordingArray = [];

    this.recordingindex = this.myGrid.getselectedrowindexes();
    this.recordingindex.forEach((field) => {
      const row = this.myGrid.getrowdata(field);
      this.recordingArray.push(row);
    });
  }
  refreshGrid() {

    var isUserlogin = this.backendService.CheckIsUserLoggedIn();
    if (isUserlogin) {
      this.isRefresh = true;
      this.requiredJobsArray = [];
      this.nonRequiredJobsArray = [];
      this.myGrid.clearselection();
      this.updateDownloadActionButtonState();
      this.getJobsByStatus(this.hidestatus);
      setTimeout(() => this.updateDownloadActionButtonState(), 0);
      this.heightOffset = 120;
    }

  }
  removeSelectedRows() {
    this.myGrid.clearselection();
    this.recordingindex = [];
    this.requiredJobsArray = [];
    this.nonRequiredJobsArray = [];
  }

  calcProgress(fileObj: any, IsProgress: any, progressEvent: any) {
    if (IsProgress) {
      this.progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    }
  }
  sweetalert() {
    var unRequiredJobs = 0;
    var requiredstring = "";
    var reqsubstring = "";
    var titleString = "Confirmation"
    if (this.mode == "download") {
      if (this.completedJobIdArray.length > 0) {
        unRequiredJobs = this.recordingindex.length - this.completedJobIdArray.length;
        requiredstring = "You have selected " + unRequiredJobs + " uncompleted job(s) and " + this.completedJobIdArray.length + " completed job. Uncompleted job(s) are unable to download. ";
      }
      reqsubstring = "Do you want to " + this.mode + " the " + (this.mode == "download" ? "job" : "selected " + this.recordingindex.length + " job(s)") + "?"
    }
    if (this.mode == "unhide") {
      if (this.nonRequiredJobsArray.length > 0) {
        unRequiredJobs = this.nonRequiredJobsArray.length;
        requiredstring = "You have selected " + unRequiredJobs + " unhidden job(s) and " + this.requiredJobsArray.length + " hidden job(s). Unhidden job(s) are unable to modify. ";
      }
      reqsubstring = "Do you want to " + this.mode + " the selected " + this.requiredJobsArray.length + " hidden job(s)?"
    }
    if (this.mode == "hide") {
      if (this.nonRequiredJobsArray.length > 0) {
        unRequiredJobs = this.nonRequiredJobsArray.length;
        requiredstring = "You have selected " + unRequiredJobs + " hidden job(s) and " + this.requiredJobsArray.length + " unhidden job(s). Hidden job(s) are unable to modify. ";
      }
      reqsubstring = "Do you want to " + this.mode + " the selected " + this.requiredJobsArray.length + " unhidden job(s)?"
    }
    if (this.mode == "delete") {
      reqsubstring = "Do you want to " + this.mode + " the selected " + this.recordingindex.length + " job(s)?"
    }
    if (this.mode == "resubmit") {
      reqsubstring = "Do you want to " + this.mode + " the selected " + this.recordingindex.length + " job(s)?"
    }
    if (this.mode == "editdraft") {
      titleString = "Confirmation";
      reqsubstring = "Your professional edit request will be processed within the standard turnaround time as defined for your account.  Thank you!";
    }
    if (this.mode == "audioDownload") {
      reqsubstring = "Do you want to download the selected audio?"
    }
    if (this.mode == "zipDownload") {
      reqsubstring = "Do you want to download Zip?"
    }
    Swal.fire({
      customClass: {
        popup: 'format-pre2'
      },
      title: titleString,
      text: (unRequiredJobs > 0 ? requiredstring : "") + reqsubstring,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `Cancel`,
      confirmButtonColor: '#187EB1',
      cancelButtonColor: '#5b5b5b',
    }).then(async (result) => {
      if (result.value) {
        if (this.mode == "audioDownload") {
          this.audioDownload();
        }
      }
    })
  }
  onRecordingDetailsWindowClose(): void {
    this.annotationsComponent.closeAnnotationWindow();
    this.clearActiveTranscription();
    this.stopPlayer();
    this.closeAnnotationPanel();

    if (this.isDetailWindowMode) {
      window.close();
    }
  }


  async downloadImageClick() {
    this.audioDownload();
  }
  async getDownloadData(jobId: any, isDraft: any, RecordingId: any) {
    const downloadData = this.getJSONResponse(await this.backendService.getDownloadURLByJobId(jobId, isDraft, RecordingId).toPromise());
    this.downloadFilesArray.push(downloadData.data);
  }
  async downloadSingleOrmultipleFile() {
    this.spinner.show();
    const row = this.myGrid.getrowdata(this.recordingindex[0]);
    await this.getDownloadData(row.jobId, false, row.id).then(res => {
      for (let i = 0; i < this.downloadFilesArray[0].downloadUrls.length; i++) {
        this.downloadAsSingleFile(this.downloadFilesArray[0].downloadUrls[i], this.downloadFilesArray[0].fileNames[i]);
      }
    });
  }
  downloadAsSingleFile(url: any, fileName: any) {
    axios({
      headers: {
        'Access-Control-Allow-Origin': '*'
      },
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        this.myGrid.clearselection();
        this.spinner.hide();
      })
      .catch(err => {
        console.log(err);
        this.spinner.hide();
      });
  }
  playNextAudio(audioRef: HTMLAudioElement) {
    if (this.currentAudioIndex < this.audioList.length - 1) {
      this.changeAudio(audioRef, ++this.currentAudioIndex);
    }
  }

  playPreviousAudio(audioRef: HTMLAudioElement) {
    if (this.currentAudioIndex > 0) {
      this.changeAudio(audioRef, --this.currentAudioIndex);
    }
  }

  pauseAudio(audioRef: HTMLAudioElement) {
    audioRef.pause();
    this.IsAudioPlay = false;
    this.isAudioPlaying = false;
  }

  toggleAudioPlayPause() {
    const audio = this.audioRef?.nativeElement;
    if (!audio) {
      return;
    }

    if (audio.paused || audio.ended) {
      if (this.audioCurrentTime < this.playbackStart || this.audioCurrentTime >= this.playbackEnd) {
        this.seekTo(this.playbackStart);
      }
      audio.volume = this.audioVolume;
      // Once the channels panel has routed the player through Web Audio, a suspended context means silence.
      this.playbackChannels.resume();
      audio.play().then(() => {
        this.audioStarted = true;
        this.isAudioPlaying = true;
      }).catch((err) => {
        console.warn('Play prevented:', err);
      });
    } else {
      audio.pause();
      this.isAudioPlaying = false;
    }
  }

  onAudioLoadedMetadata() {
    this.processEvents(this.selectedRecording.recordingDetails ? this.selectedRecording.recordingDetails : '');
    //this.audioDuration = audio.duration || 0;
    //this.updateAudioProgress();
  }

  // onAudioTimeUpdate() {
  //   const audio = this.audioRef?.nativeElement;
  //   if (!audio) {
  //     return;
  //   }
  //   this.audioCurrentTime = audio.currentTime;
  //   this.updateAudioProgress();
  // }
  onAudioTimeUpdate(): void {
    const audio = this.audioRef?.nativeElement;
    if (!audio) return;

    const realTime = audio.currentTime;
    const { virtualTime, insidePause, nextRealStart } = this.mapMediaToVirtual(realTime);

    if (insidePause && nextRealStart !== undefined) {
      audio.currentTime = nextRealStart;
      return;
    }

    if (virtualTime >= this.playbackEnd) {
      audio.pause();
      this.isAudioPlaying = false;
      this.audioCurrentTime = this.playbackEnd;
      audio.currentTime = this.mapVirtualToMedia(this.playbackEnd);
      return;
    }

    this.audioCurrentTime = virtualTime;
  }

  private getRealTimestampForVirtualTime(virtualTime: number): Date {
    const audioStartMs = this.selectedRecording?.startedAt
      ? new Date(this.selectedRecording.startedAt).getTime()
      : 0;

    for (const seg of this.activeSegments) {
      if (virtualTime >= seg.virtualStart && virtualTime <= seg.virtualEnd) {
        const realOffsetSeconds = seg.realStart + (virtualTime - seg.virtualStart);
        return new Date(audioStartMs + realOffsetSeconds * 1000);
      }
    }

    // Fallback if at the very end
    if (this.activeSegments.length > 0) {
      const lastSeg = this.activeSegments[this.activeSegments.length - 1];
      return new Date(audioStartMs + lastSeg.realEnd * 1000);
    }

    return new Date(audioStartMs);
  }

  /**
   * Formats current playback position to match wall-clock time (jumping over pause gaps)
   */
  formatClockTime(offsetSeconds: number): string {
    if (!this.selectedRecording?.startedAt) return '00:00:00';

    const currentClockDate = this.getRealTimestampForVirtualTime(offsetSeconds);

    const hours = currentClockDate.getHours().toString().padStart(2, '0');
    const minutes = currentClockDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentClockDate.getSeconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
  //
  processEvents(jsonString: string): void {
    this.activeSegments = [];
    this.audioDuration = 0;
    this.mediaIncludesPauseGaps = true;
    try {
      const data = JSON.parse(jsonString || '{}');
      const audioStartMs = this.toUtcDate(data.AudioStart)?.getTime();
      const nativeAudioDuration = this.audioRef?.nativeElement?.duration;
      const finiteMediaDuration = Number.isFinite(nativeAudioDuration) && nativeAudioDuration > 0
        ? nativeAudioDuration : null;
      if (audioStartMs === undefined) {
        this.audioDuration = finiteMediaDuration || 0;
        this.mediaIncludesPauseGaps = false;
        return;
      }
      const effectiveAudioEndMs = this.toUtcDate(data.AudioEnd)?.getTime()
        ?? (audioStartMs + (finiteMediaDuration || 0) * 1000);
      if (effectiveAudioEndMs < audioStartMs) {
        return;
      }
      const events = (Array.isArray(data.Events) ? data.Events : [])
        .map(event => ({ action: event.Action, time: this.toUtcDate(event.Time)?.getTime() }))
        .filter(event => event.time !== undefined && event.time >= audioStartMs && event.time <= effectiveAudioEndMs)
        .sort((first, second) => first.time! - second.time!);

      const segments: ActiveSegment[] = [];
      let currentSegmentStartMs: number | null = audioStartMs;
      let accumulatedVirtualTime = 0;
      const appendSegment = (endMs: number): void => {
        if (currentSegmentStartMs === null || endMs <= currentSegmentStartMs) {
          return;
        }
        const durationSec = (endMs - currentSegmentStartMs) / 1000;
        segments.push({
          realStart: (currentSegmentStartMs - audioStartMs) / 1000,
          realEnd: (endMs - audioStartMs) / 1000,
          virtualStart: accumulatedVirtualTime,
          virtualEnd: accumulatedVirtualTime + durationSec
        });
        accumulatedVirtualTime += durationSec;
      };
      for (const event of events) {
        if (event.action === 'Paused' && currentSegmentStartMs !== null) {
          appendSegment(event.time!);
          currentSegmentStartMs = null;
        } else if (event.action === 'Resumed' && currentSegmentStartMs === null) {
          currentSegmentStartMs = event.time!;
        }
      }
      appendSegment(effectiveAudioEndMs);

      this.activeSegments = segments;
      this.audioDuration = accumulatedVirtualTime;
      if (finiteMediaDuration !== null) {
        const wallDuration = (effectiveAudioEndMs - audioStartMs) / 1000;
        this.mediaIncludesPauseGaps = Math.abs(finiteMediaDuration - wallDuration)
          <= Math.abs(finiteMediaDuration - accumulatedVirtualTime);
      }
      if (this.selectedCaseDetail) {
        this.applyCaseAudioWindow(this.selectedCaseDetail);
      }
    } catch (e) {
      console.error('Error parsing events JSON:', e);
    }
  }
  private mapVirtualToMedia(virtualTime: number): number {
    return this.mediaIncludesPauseGaps ? this.mapVirtualToReal(virtualTime) : virtualTime;
  }

  private mapMediaToVirtual(mediaTime: number): { virtualTime: number; insidePause: boolean; nextRealStart?: number } {
    return this.mediaIncludesPauseGaps
      ? this.mapRealToVirtual(mediaTime)
      : { virtualTime: Math.max(0, Math.min(mediaTime, this.audioDuration)), insidePause: false };
  }

  private mapVirtualToReal(virtualTime: number): number {
    for (const seg of this.activeSegments) {
      if (virtualTime >= seg.virtualStart && virtualTime <= seg.virtualEnd) {
        return seg.realStart + (virtualTime - seg.virtualStart);
      }
    }
    return 0;
  }

  private mapRealToVirtual(realTime: number): { virtualTime: number; insidePause: boolean; nextRealStart?: number } {
    for (const seg of this.activeSegments) {
      if (realTime >= seg.realStart && realTime <= seg.realEnd) {
        return {
          virtualTime: seg.virtualStart + (realTime - seg.realStart),
          insidePause: false
        };
      }
    }
    const nextSeg = this.activeSegments.find((seg) => seg.realStart > realTime);
    if (nextSeg) {
      return { virtualTime: nextSeg.virtualStart, insidePause: true, nextRealStart: nextSeg.realStart };
    }
    return { virtualTime: this.audioDuration, insidePause: false };
  }
  onAudioEnded() {
    this.isAudioPlaying = false;
    this.audioCurrentTime = this.playbackStart;
  }


  seekAudio(event: MouseEvent) {
    const audio = this.audioRef?.nativeElement;
    if (!audio || !this.audioDuration) {
      return;
    }
    const progressEl = event.currentTarget as HTMLElement;
    const rect = progressEl.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    audio.currentTime = (clickX / rect.width) * this.audioDuration;
  }

  onVolumeChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = parseFloat(input.value);
    this.audioVolume = isNaN(value) ? 1 : value;
    const audio = this.audioRef?.nativeElement;
    if (audio) {
      audio.volume = this.audioVolume;
    }
  }

  // store the previous volume to support mute/unmute toggle
  previousVolume: number = 1;

  // seekTo(value: any) {
  //   const audio = this.audioRef?.nativeElement;
  //   if (!audio) return;
  //   const v = parseFloat(value);
  //   if (!isNaN(v)) {
  //     audio.currentTime = v;
  //     this.onAudioTimeUpdate();
  //   }
  // }
  seekTo(value: any): void {
    const requested = Number(value);
    if (isNaN(requested)) {
      return;
    }
    const virtualTime = Math.max(this.playbackStart, Math.min(this.playbackEnd, requested));
    const targetRealTime = this.mapVirtualToMedia(virtualTime);

    if (this.audioRef?.nativeElement) {
      this.audioRef.nativeElement.currentTime = targetRealTime;
      this.audioCurrentTime = virtualTime;
    }
  }
  toggleMute() {
    const audio = this.audioRef?.nativeElement;
    if (!audio) return;
    if (this.audioVolume > 0) {
      this.previousVolume = this.audioVolume;
      this.audioVolume = 0;
      audio.volume = 0;
    } else {
      this.audioVolume = this.previousVolume || 1;
      audio.volume = this.audioVolume;
    }
  }

  private updateAudioProgress() {
    if (!this.audioDuration || this.audioDuration === 0) {
      this.audioProgressPercent = 0;
      return;
    }
    this.audioProgressPercent = Math.min(100, (this.audioCurrentTime / this.audioDuration) * 100);
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds) || seconds === Infinity) {
      return '00:00:00';
    }
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const hh = hrs.toString().padStart(2, '0');
    const mm = mins.toString().padStart(2, '0');
    const ss = secs.toString().padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  }

  private changeAudio(audioRef: HTMLAudioElement, index: number) {
    audioRef.pause();
    audioRef.currentTime = 0;
    this.fileToPlay = this.audioList[index];
    audioRef.load();
    audioRef.play();
  }

  private async playHlsForRoom(roomName: string): Promise<void> {
    try {
      this.spinner.show();
      this.IsAudioPlay = true;
      this.isAudioPlaying = false;
      this.audioStarted = false;
      this.audioVolume = 1;
      this.audioCurrentTime = 0;
      this.audioDuration = 0;
      this.audioProgressPercent = 0;
      this.hlsUrl = await firstValueFrom(this.backendService.getstreamingplaybackdetails(roomName));
      this.fileToPlay = this.hlsUrl;
      this.audioList = [this.hlsUrl];
      this.currentAudioIndex = 0;
      this.cdRef.detectChanges();
      await this.attachHlsToAudio();
    } catch (error) {
      console.error('Failed to load HLS playback URL for room', roomName, error);
      this.sendNotification('Unable to load audio playback details.', 'error');
      this.IsAudioPlay = false;
    } finally {
      this.spinner.hide();
    }
  }
  private async attachHlsToAudio(): Promise<void> {
    const audio = this.audioRef?.nativeElement;
    if (!audio) {
      return;
    }

    if (this.hls) {
      this.hls.destroy();
      this.hls = undefined;
    }

    audio.volume = this.audioVolume;

    if (Hls.isSupported()) {
      this.hls = new Hls({
        debug: false,
      });
      this.hls.loadSource(this.hlsUrl);
      this.hls.attachMedia(audio);
      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.audioStarted = false;
      });
      this.hls.on(Hls.Events.BUFFER_CODECS, (_, data) => {
        this.playbackChannels.setChannelCount(data.audio?.metadata?.channelCount);
      });
      this.hls.on(Hls.Events.ERROR, (event, data) => {
        console.error('HLS.js error:', event, data);
      });
    } else {
      audio.src = this.hlsUrl;
      audio.load();
      this.audioStarted = false;
    }
  }

  // private async attachHlsToAudio(): Promise<void> {
  //   const audio = this.audioRef?.nativeElement;
  //   if (!audio) {
  //     return;
  //   }

  //   if (this.hls) {
  //     this.hls.destroy();
  //     this.hls = undefined;
  //   }

  //   audio.volume = this.audioVolume;

  //   if (Hls.isSupported()) {
  //     this.hls = new Hls({
  //       debug: false,
  //     });
  //     this.hls.loadSource(this.hlsUrl);
  //     this.hls.attachMedia(audio);
  //     this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
  //       this.audioStarted = false;
  //     });
  //     this.hls.on(Hls.Events.ERROR, (event, data) => {
  //       console.error('HLS.js error:', event, data);
  //     });
  //   } else {
  //     audio.src = this.hlsUrl;
  //     audio.load();
  //     this.audioStarted = false;
  //   }
  // }
  stopPlayer() {
    const audio = this.audioRef?.nativeElement;
    if (audio) {
      audio.pause();          // Stops the audio from playing
      audio.currentTime = 0;   // Resets the track back to the very beginning
    }
    this.audioStarted = false;
    this.isAudioPlaying = false;
    console.log('Player stopped');
  }
  sendNotification(message: any, messageType: any) {
    this.msgNotification.elementRef.nativeElement.querySelector('.jqx-notification-content').innerHTML = message;
    this.msgNotification.template(messageType);
    this.msgNotification.open();
  }
  ngOnDestroy(): void {
    if (this.viewRecordingDetails) {
      this.viewRecordingDetails.close();
    }
    this.annotationsComponent.closeAnnotationWindow();
    this.clearActiveTranscription();
    this.stopPlayer();
    this.playbackChannels.close();
  };

  /** Opening the channels menu is a click, so the player can be routed through Web Audio here. */
  attachPlaybackChannels(): void {
    const audio = this.audioRef?.nativeElement;
    if (audio) {
      this.playbackChannels.attach(audio);
    }
  }
  private clearActiveTranscription(): void {
    this.transcriptionText = '';
    this.finalTranscriptionSegments = [];
    this.wordCount = 0;
    this.characterCount = 0;
    this.lastUpdated = null;
  }
  async loadOrganizationValues() {
    try {
      this.organizationOptions = [];

      const response: any = await this.backendService.getCustomers().toPromise();

      const list = response?.data?.customerList || [];

      this.organizationOptions = [
        { label: 'All', value: 'All' },
        ...response.data.customerList.map((org: any) => ({
          label: org.customerName,   // ✅ FIXED
          value: org.custExtId
        }))
      ];

      // ✅ Select default
      setTimeout(() => {
        this.myDropDownList.selectIndex(0);
      });

    } catch (error) {
      console.error('Error loading organizations:', error);

      // fallback
      this.organizationOptions = [{ label: 'All', value: 'All' }];
    }
  }
  async loadDeparmentValues() {
    try {
      this.departmentOptions = [];

      const departmentListDetails =
        await this.backendService.getDepartments().toPromise();

      const departmentList =
        this.backendService.getJSONResponse(
          departmentListDetails['data'].departmentList
        );

      // Add All
      this.departmentOptions.push({
        id: 'All',
        name: 'All',
        deptExtId: 'All',
        orgExtId: 'All'
      });

      // Add departments
      for (const department of departmentList) {
        this.departmentOptions.push({
          id: department.id,
          name: `${department.name} (${department.organizationname})`,
          deptExtId: department.deptExtId,
          orgExtId: department.orgExtId
        });
      }

      // Create JQX dropdown source
      this.departmentDropdownOptions = this.departmentOptions.map(dept => ({
        label: dept.name,
        value: dept.id
      }));

      //console.log('departmentOptions:', this.departmentOptions);
      //console.log('departmentDropdownOptions:', this.departmentDropdownOptions);

    } catch (error) {
      console.error('Error loading departments:', error);
    }
  }
  async DownloadTranscriptionFromServer(roomName: string): Promise<void> {
    try {
      console.log('💾 DownloadTranscriptionFromServer ', roomName);
      const payload: GetFileUploadModel = {
        fileName: roomName + ".html",
        contentType: "text/html",
        roomName: roomName,
        fileType: "Transcription"
      };

      const response: any = await this.backendService.getFileDownloadURL(payload).toPromise();
      console.log('💾  transcription result', response);
      const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;


      if (parsedResponse && parsedResponse.success && parsedResponse.data?.presignedUrl) {
        const targetUrl = parsedResponse.data.presignedUrl;
        console.log('💾 Downloading transcription HTML from URL:', targetUrl);

        try {
          // Fetch the HTML content directly as text
          const htmlContent = await firstValueFrom(
            this.httpClient.get(targetUrl, { responseType: 'text' })
          );

          // Assign directly to your editor model
          this.editableTranscriptionContent = htmlContent;

        } catch (error) {
          console.error('Error downloading HTML transcription:', error);
          this.editableTranscriptionContent = ''; // Fallback for empty state
        }
      }
      else {
        console.error('Failed to get a valid pre-signed URL', parsedResponse);
        this.transcriptionText = "";
      }
    } catch (err) {
      console.error('Error in DownloadTranscriptionFromServer', err);
      this.transcriptionText = "";
    }
  }
  private normalizeTranscriptText(value: any): string {
    return typeof value === 'string' ? value.trim() : '';
  }
  private resolveTranscriptStartSeconds(transcript: TranscriptResponse): number {
    const words = transcript.words || [];

    // 1. min(words.start > 0) — raw elapsed seconds from word timings
    const validStarts = words.map(w => w.start).filter(s => s > 0);
    if (validStarts.length) {
      return Math.min(...validStarts);
    }

    // 2. transcript.timestamp is stored as epoch ms by normalizeTimestamp.
    //    Divide by 1000 to get seconds so formatTimestamp can do:
    //      recordingStartTime + seconds * 1000
    //    If it's a large absolute epoch ms (> 1e11) pass it through directly.
    if (transcript.timestamp > 0) {
      return transcript.timestamp > 1e11 ? transcript.timestamp : transcript.timestamp / 1000;
    }

    return 0;
  }

  private resolveTranscriptEndSeconds(transcript: TranscriptResponse, start: number): number {
    const words = transcript.words || [];

    // 1. max(words.end > 0)
    const validEnds = words.map(w => w.end).filter(e => e > 0);
    if (validEnds.length) {
      return Math.max(...validEnds);
    }

    // 2. end_time / endTime field as-is
    const rawEnd = (transcript as any).end_time ?? (transcript as any).endTime;
    if (rawEnd > 0) {
      return rawEnd;
    }

    // 3. start + duration
    if (transcript.duration > 0) {
      return start + transcript.duration;
    }

    return start;
  }
  private resolveSpeakerKey(transcript: TranscriptResponse): string {
    const raw = this.normalizeTranscriptText(
      transcript.speaker ||
      transcript.participant_identity ||
      transcript.participant ||
      'Speaker'
    );
    // Normalise to "speaker:N" when name contains a number, else use lowercase name
    const num = this.extractSpeakerNumber(raw);
    return num > 0 ? `speaker:${num}` : `name:${raw.toLowerCase()}`;
  }

  private resolveSpeakerLabel(speakerKey: string): string {
    if (speakerKey.startsWith('speaker:')) {
      const num = speakerKey.replace('speaker:', '');
      return `Speaker ${num}`;
    }
    if (speakerKey.startsWith('name:')) {
      const name = speakerKey.replace('name:', '');
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
    return 'Speaker';
  }
  private extractSpeakerNumber(speaker: string): number {
    const match = (speaker || '').match(/(\d+)/);
    return match ? Number(match[1]) : 0;
  }
  private loadTranscriptResponses(transcripts: TranscriptResponse[]): void {
    for (const transcript of transcripts) {
      const originalText = this.normalizeTranscriptText(transcript.text);
      if (!originalText) {
        continue;
      }

      const translatedText = this.normalizeTranscriptText(transcript.translated_text);
      const hasTranslation = !!translatedText && translatedText !== originalText;
      const englishText = hasTranslation ? translatedText : originalText;

      const start = this.resolveTranscriptStartSeconds(transcript);
      const end = this.resolveTranscriptEndSeconds(transcript, start);
      const speakerKey = this.resolveSpeakerKey(transcript);
      const speakerLabel = this.resolveSpeakerLabel(speakerKey);
      const speakerNumber = this.extractSpeakerNumber(speakerLabel);
      // transcript.timestamp is already elapsed ms (normalized in toTranscriptResponse).
      // Add to recordingStartTime to get an absolute epoch ms.
      const timestamp = transcript.timestamp;
      const newSeg: TranscriptionViewSegment = {
        speaker: speakerLabel,
        speakerNumber,
        speakerKey,
        text: originalText,
        translatedText: hasTranslation ? englishText : '',
        translationTarget: transcript.translation_target,
        language: transcript.language,
        timestamp,
        startTime: start,
        endTime: end,
        duration: transcript.duration
      };
      this.finalTranscriptionSegments.push(newSeg);


    }
    this.syncTranscriptionSnapshots();
  }



  private updateTranscriptionStats(): void {
    const trimmed = this.transcriptionText.trim();
    this.wordCount = trimmed ? trimmed.split(/\s+/).length : 0;
    this.characterCount = this.transcriptionText.length;
    this.lastUpdated = new Date();
  }
  private syncTranscriptionSnapshots(): void {
    console.log('Syncing transcription snapshots. Total segments:', this.finalTranscriptionSegments);
    const finalText = this.finalTranscriptionSegments
      .map(seg => `${this.buildSegmentHeaderText(seg)}\n${this.buildSegmentBodyText(seg)}`)
      .join('\n\n');

    this.transcriptionText = finalText;
    this.updateTranscriptionStats();
  }
  private buildSegmentHeaderText(segment: TranscriptionViewSegment, interim: boolean = false): string {
    const start = this.formatTimestamp(segment.startTime);
    const end = this.formatTimestamp(segment.endTime);
    const timestampText = `[${start} - ${end}] `;
    return `${timestampText}🎙️ ${segment.speaker}${interim ? ' (interim)' : ''}:`;
  }
  private buildSegmentBodyText(segment: TranscriptionViewSegment): string {
    if (this.hasSegmentTranslation(segment)) {
      return `(source): ${segment.text}\n(translated): ${segment.translatedText}`;
    }
    return segment.text;
  }
  hasSegmentTranslation(segment: TranscriptionViewSegment): boolean {
    const source = this.normalizeTranscriptText(segment?.text);
    const translated = this.normalizeTranscriptText(segment?.translatedText);
    return !!translated && translated !== source;
  }
  isMultilingualRecording(): boolean {
    return (this.selectedRecording?.language || '').toLowerCase() === 'multi';
  }

  hasNonEmptyText(value: string | null | undefined): boolean {
    return !!value && value.trim().length > 0;
  }
  // Escape HTML to keep content safe inside generated document
  private escapeHtml(unsafe: any): string {
    if (unsafe === null || unsafe === undefined) return '';
    return String(unsafe)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }



  // Build a Word-compatible HTML document (opened by MS Word) and trigger download
  downloadTranscriptionDocx(): void {
    // 1. Get the raw HTML content from the editor or fallback to empty state
    const bodyContent = this.editableTranscriptionContent && this.editableTranscriptionContent.trim()
      ? this.editableTranscriptionContent
      : `<div style="color:#a0aec0; text-align:center;">No transcription available.</div>`;

    // 2. Build HTML shell with inline CSS for MS Word rendering
    let html = `<!doctype html><html><head><meta charset="utf-8"><title>Transcription</title>`;

    // Add CSS styles inside <head> so MS Word renders cards and left borders properly
    html += `<style>
    body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #2d3748; padding: 12px; }
    .transcription-segment {
      background-color: #ffffff;
      border: 1px solid #e2e8f0;
      border-left: 4px solid #3b82f6;
      border-radius: 6px;
      padding: 12px 16px;
      margin-bottom: 12px;
    }
    .transcription-speaker {
      font-weight: 600;
      font-size: 14px;
      color: #1e3a8a;
      display: block;
      margin-bottom: 4px;
    }
  </style>`;

    html += `</head><body>`;
    html += `<div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color:#2d3748; padding:12px;">`;
    html += `<h3 style="margin:0 0 8px 0;">${this.escapeHtml(this.selectedRecording?.fileName || 'Transcription')}</h3>`;
    html += `<div style="font-size:13px; color:#666; margin-bottom:16px;">`;
    html += `Words: ${this.wordCount || 0} &nbsp; Characters: ${this.characterCount || 0} &nbsp; Last Updated: ${this.lastUpdated ? this.lastUpdated.toLocaleString() : ''}`;
    html += `</div>`;

    // Insert Froala HTML content directly (Unescaped)
    html += bodyContent;

    html += `</div></body></html>`;

    // 3. Create Blob and trigger download
    const blob = new Blob(['\ufeff', html], { type: 'application/msword' });
    const filename = (this.selectedRecording?.fileName || 'transcription') + '.doc';
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    link.remove();
  }

  // Froala Editor Methods
  private syncEditableContentToEditor(): void {
    if (this.activeFroalaEditor?.html) {
      this.activeFroalaEditor.html.set(this.editableTranscriptionContent);
    }
  }

  private escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  private clearFindHighlights(content: string): string {
    return content.replace(/<mark class="find-match">/g, '').replace(/<\/mark>/g, '');
  }

  registerFroalaEditorCommands(): void {
    FroalaEditor.DefineIconTemplate('find-replace-icon', '<i class="material-icons">find_replace</i>');
    FroalaEditor.DefineIcon('find-replace', { NAME: 'Find Replace', template: 'find-replace-icon' });
    FroalaEditor.RegisterCommand('find-replace', {
      title: 'Find Replace',
      focus: false,
      undo: false,
      callback: () => this.toggleFindReplace()
    });

    FroalaEditor.RegisterCommand('find-replace-all', {
      title: 'Replace All',
      focus: false,
      undo: false,
      callback: () => this.onReplaceAll()
    });

    FroalaEditor.RegisterCommand('close-find-replace', {
      title: 'Close Find Replace',
      focus: false,
      undo: false,
      callback: () => this.closeFindReplacePanel()
    });

    FroalaEditor.DefineIconTemplate('speaker', '<i class="material-icons-outlined">record_voice_over</i>');
    FroalaEditor.DefineIcon('add-speaker', { NAME: 'Add Speaker', template: 'speaker' });
    FroalaEditor.RegisterCommand('add-speaker', {
      title: 'Add Speaker',
      focus: false,
      undo: true,
      callback: () => this.insertSpeakerMarker()
    });

    FroalaEditor.RegisterCommand('allCaps', {
      title: 'All Caps',
      icon: '<i class="material-icons">text_fields</i>',
      focus: false,
      undo: true,
      callback: () => this.toggleAllCaps()
    });
  }

  insertSpeakerMarker(): void {
    const editor = this.activeFroalaEditor;
    if (!editor) {
      return;
    }

    const marker = '<span style="font-weight:600;color:#1976d2;">[Speaker]</span> ';
    editor.html.insert(marker);
    this.editableTranscriptionContent = editor.html.get();
  }

  toggleAllCaps(): void {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      return;
    }

    const range = selection.getRangeAt(0);
    const selectedText = range.toString();
    if (!selectedText.trim()) {
      return;
    }

    const fragment = range.extractContents();
    const replacement = document.createTextNode(selectedText.toUpperCase());
    range.insertNode(replacement);
    selection.removeAllRanges();
    selection.addRange(range);

    if (this.activeFroalaEditor?.html) {
      this.editableTranscriptionContent = this.activeFroalaEditor.html.get();
    }
  }

  toggleFindReplace(): void {
    this.showFindReplacePanel = true;
    this.findReplaceCurrentIndex = 0;
    this.findReplaceMatches = [];

    const selection = window.getSelection();
    const selectedText = selection?.toString().trim();
    if (selectedText) {
      this.findWhatText = selectedText;
    }

    this.findReplacePopup?.open();
  }

  onFindText(): void {
    if (!this.findWhatText.trim()) {
      Swal.fire({ title: 'Find text is required', icon: 'warning', confirmButtonText: 'OK' });
      return;
    }

    const content = this.clearFindHighlights(this.editableTranscriptionContent);
    const flags = this.isFindReplaceCaseSensitive ? 'g' : 'gi';
    const regex = new RegExp(this.escapeRegExp(this.findWhatText), flags);
    const matches = Array.from(content.matchAll(regex));

    if (!matches.length) {
      Swal.fire({ title: 'No matches found', icon: 'info', confirmButtonText: 'OK' });
      return;
    }

    const currentMatch = matches[this.findReplaceCurrentIndex % matches.length];
    if (!currentMatch.index) {
      this.findReplaceCurrentIndex = 0;
    }

    const highlightedContent = content.slice(0, currentMatch.index) + '<mark class="find-match">' + currentMatch[0] + '</mark>' + content.slice(currentMatch.index! + currentMatch[0].length);
    this.editableTranscriptionContent = highlightedContent;
    this.syncEditableContentToEditor();
    this.findReplaceCurrentIndex = (this.findReplaceCurrentIndex + 1) % matches.length;
  }

  onReplace(): void {
    if (!this.findWhatText.trim()) {
      Swal.fire({ title: 'Find text is required', icon: 'warning', confirmButtonText: 'OK' });
      return;
    }

    if (!this.replaceWithText.trim()) {
      Swal.fire({ title: 'Replace text is required', icon: 'warning', confirmButtonText: 'OK' });
      return;
    }

    const content = this.clearFindHighlights(this.editableTranscriptionContent);
    const flags = this.isFindReplaceCaseSensitive ? 'g' : 'gi';
    const regex = new RegExp(this.escapeRegExp(this.findWhatText), flags);
    const matches = Array.from(content.matchAll(regex));

    if (!matches.length) {
      Swal.fire({ title: 'No matches found', icon: 'info', confirmButtonText: 'OK' });
      return;
    }

    const currentIndex = this.findReplaceCurrentIndex > 0 ? this.findReplaceCurrentIndex - 1 : 0;
    const currentMatch = matches[Math.min(currentIndex, matches.length - 1)];
    const before = content.slice(0, currentMatch.index);
    const after = content.slice(currentMatch.index! + currentMatch[0].length);
    this.editableTranscriptionContent = before + this.replaceWithText + after;
    this.syncEditableContentToEditor();
  }

  onReplaceAll(): void {
    if (!this.findWhatText.trim()) {
      Swal.fire({ title: 'Find text is required', icon: 'warning', confirmButtonText: 'OK' });
      return;
    }

    if (!this.replaceWithText.trim()) {
      Swal.fire({ title: 'Replace text is required', icon: 'warning', confirmButtonText: 'OK' });
      return;
    }

    const content = this.clearFindHighlights(this.editableTranscriptionContent);
    const flags = this.isFindReplaceCaseSensitive ? 'g' : 'gi';
    const regex = new RegExp(this.escapeRegExp(this.findWhatText), flags);
    this.editableTranscriptionContent = content.replace(regex, this.replaceWithText);
    this.syncEditableContentToEditor();
    this.findReplaceCurrentIndex = 0;
    this.findReplaceMatches = [];
  }

  closeFindReplacePanel(): void {
    this.editableTranscriptionContent = this.clearFindHighlights(this.editableTranscriptionContent);
    this.syncEditableContentToEditor();
    this.showFindReplacePanel = false;
    this.findWhatText = '';
    this.replaceWithText = '';
    this.findReplaceCurrentIndex = 0;
    this.findReplaceMatches = [];
    this.findReplacePopup?.close();
  }

  toggleTranscriptionEditMode(): void {
    if (!this.isTranscriptionEditMode) {
      // Enter edit mode
      this.isTranscriptionEditMode = true;
      // Initialize editable content from current grouped segments
      //this.editableTranscriptionContent = this.getTranscriptionAsHtml();
    }
  }

  enterTranscriptionEditMode(): void {
    this.isTranscriptionEditMode = true;

    // Ensure editableTranscriptionContent keeps the HTML string downloaded from S3.
    // We do NOT overwrite it with a generator function or set it to empty/undefined.
    if (!this.editableTranscriptionContent) {
      this.editableTranscriptionContent = '';
    }
  }

  exitTranscriptionEditMode(): void {
    this.isTranscriptionEditMode = false;
    this.applyCaseTranscriptionFilter(this.selectedCaseDetail);
  }

  async saveTranscriptionEdits() {
    this.spinner.show();
    const payload: GetFileUploadModel = {
      fileName: this.selectedRecording.roomName + ".html",
      contentType: "text/html",
      roomName: this.selectedRecording.roomName ? this.selectedRecording.roomName : '',
      fileType: "Transcription"
    };
    var response = await this.backendService.getFileUploadURL(payload).toPromise();
    console.log('💾  transcription result', response);
    const parsedResponse = typeof response === 'string' ? JSON.parse(response) : response;
    if (parsedResponse.success && parsedResponse.data?.presignedUrl) {
      const targetUrl = parsedResponse.data.presignedUrl;
      await this.uploadTranscriptToS3(targetUrl);
      await this.exitTranscriptionEditMode();
      this.sendNotification('Transcription updated successfully.', 'success');
      this.spinner.hide();
    }
  }

  public uploadTranscriptToS3(presignedUrl: string): void {
    // Send the model object directly. Angular's HttpClient will serialize it to JSON.
    const htmlContent = this.editableTranscriptionContent;

    // 2. Set Content-Type to text/html
    const headers = new HttpHeaders({ 'Content-Type': 'text/html' });

    console.log('📤 Uploading transcription HTML to S3 (object PUT)...');

    // 3. Upload the HTML string directly as the body
    this.httpClient.put(presignedUrl, htmlContent, { headers, responseType: 'text' as 'json' }).subscribe({
      next: () => {
        console.log('🎉 Transcription HTML uploaded to S3 successfully!');
      },
      error: (err) => {
        console.error('❌ S3 Upload failed:', err);
      }
    });
  }
  cancelTranscriptionEdits(): void {
    //this.editableTranscriptionContent = '';
    this.exitTranscriptionEditMode();
  }

  private stripHtmlTags(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }
  generateTranscriptionSummary() {
    var orgExtId = this.selectedRecording.orgExtId ? this.selectedRecording.orgExtId : '';
    this.backendService.getOrganizationByExtId(orgExtId).subscribe({
      next: async (resp: any) => {
        try {
          const org = this.backendService.getJSONResponse(resp);
          console.log('Organization data:', org.data.presetPrompts);
          this.updatePresetPromptsDDL(org.data.presetPrompts);
          this.showCustomPrompt = org.data.isCustomPromptEnable;
        } catch (error) {
          console.error('Error processing organization:', error);
        } finally {
          this.spinner.hide();
        }
      },
      error: (err) => {
        console.error('Error fetching organization:', err);
        this.spinner.hide();
      }
    });

    this.summaryWindow.open();

  }
  updatePresetPromptsDDL(prompts: any): void {
    const list = typeof prompts === 'string' ? JSON.parse(prompts || '[]') : (prompts || []);
    const mapped = list.map((p: any) => ({
      PromptId: p.promptId ?? p.PromptId,
      PromptText: p.promptText ?? p.PromptText
    }));
    this.presetPromptsOptions = [
      { PromptId: -1, PromptText: '-- Not Selected --' },
      ...mapped
    ];
    this.selectedPromptId = -1;
    this.summaryPrompt = '';
    setTimeout(() => {
      this.summaryPromptDDL?.val(-1);
    });
  }
  onSummaryOptionChange(promptId: number): void {
    this.selectedPromptId = promptId;
    this.summaryText = '';
    this.customPromptText = '';
    if (promptId === -1) {
      this.summaryPrompt = '';
      return;
    }
    const selectedPrompt = this.presetPromptsOptions.find(
      p => p.PromptId === promptId
    );
    this.summaryPrompt = selectedPrompt?.PromptText || '';
  }
  onCustomPromptChange(value: string) {
    this.customPromptText = value;
    if (value && value.trim() !== '') {
      this.selectedPromptId = -1;
      this.summaryPrompt = value.trim();
      this.summaryText = '';
    }
  }
  onSelectedRadioButton(data: MatRadioChange) {
    this.promptMode = data.value;
    if (data.value === "custom" || data.value === "summary") {
      this.selectedPromptId = -1;
      this.summaryText = '';
      this.summaryPrompt = "";
    }
  }
  onSummarySelect(event: any): void {
    if (!event?.args) return;
    const item = event.args.item;
    if (!item) return;
    const promptId = item.value;
    setTimeout(() => {
      this.onSummaryOptionChange(promptId);
    });
  }
  async getSummary() {
    const customText = this.customPromptRef?.nativeElement.value?.trim() || '';
    this.customPromptText = customText;
    if (this.selectedPromptId === -1 && customText === '') {
      this.sendNotification('Please select a valid summary prompt before generating the summary.', 'error');
      return;
    }
    this.summaryPrompt = customText !== '' ? customText : this.summaryPrompt;
    this.spinner.show();
    //const row = this.myGrid.getrowdata(this.jobindex[0]);
    var SummaryResult = await this.backendService.getDocumentSummary(0, false, "", this.summaryPrompt, this.selectedRecording.id || 0).toPromise();
    this.summaryText = this.backendService.getJSONResponse(SummaryResult['data']);
    if (this.summaryText == null || this.summaryText == undefined) {
      this.sendNotification("We are unable to fetch summary for this document.", "error");
    }
    this.spinner.hide();
  }
  
  onOrganizationChange(event: any) {
    const item = event.args.item;
    if (item) {
      this.selectedOrgExtId = item.value;
      this.getsqlData(this.selectedStartDate, this.selectedEndDate, this.statusValue, this.sourceValue, this.selectedOrgExtId, this.selectedDepartmentExtId);
    }
  }

  async departmentChangeEvent(event: any): Promise<void> {
    //console.log('event:', event);

    const selectedItem = event?.args?.item;

    if (!selectedItem) {
      return;
    }

    const selectedId = selectedItem.value;

    const selectedDepartment = this.departmentOptions.find(
      dept => dept.id === selectedId
    );

    if (!selectedDepartment) {
      return;
    }

    this.selectedDepartmentId = selectedDepartment.id;
    this.selectedDepartmentExtId = selectedDepartment.deptExtId;
    this.selectedOrgExtId = selectedDepartment.orgExtId;

    await this.getsqlData(
      this.selectedStartDate,
      this.selectedEndDate,
      this.statusValue,
      this.sourceValue,
      this.selectedOrgExtId,
      this.selectedDepartmentExtId
    );
  }
  async openAnnotationWindow() {
    this.spinner.show();
    console.log('Opening annotation window for recording:', this.selectedRecording);
    var annotationDialogModel: AnnotationDialogModel = {
      caseNumber: this.selectedRecording?.caseNumber || "Unknown Room",
      hlsUrl: this.hlsUrl,
      startTimestamp: this.selectedRecording.startedAt ?? "",
      endTimestamp: this.selectedRecording.stoppedAt ?? "",
      recordingId: this.selectedRecording.id ?? 0,
      sessionId: this.selectedRecording.roomName ?? "",
      judgeName: this.selectedRecording.judgeName ?? "",
      hearingDate: this.selectedRecording.hearingDateTime ?? "",
      caseDetailsId: this.selectedCaseDetail?.id ?? undefined
    };
    const dataModel = {
      annotationDialogModel: annotationDialogModel,
    };
    this.annotationsComponent.openAnnotationWindow(dataModel);
  }

  openAnnotationPanel(): void {
    this.previousSidebarView = this.showTimeline ? 'timeline' : 'info';
    this.showAnnotationsPanel = true;
    this.showTimeline = false;
    // Ensure the annotation component is rendered before accessing the ViewChild.
    // Call detectChanges then defer execution slightly to give Angular time to instantiate the child.
    try {
      this.cdRef.detectChanges();
    } catch (err) {
      // ignore; detectChanges may fail if called too early in some lifecycle hooks
    }
    setTimeout(() => {
      const recordingId = this.selectedRecording?.id ?? 0;
      console.log('Loading annotations for recording ID:', recordingId);
      if (this.annotationComp) {
        this.annotationComp.recordingId = recordingId;
        this.annotationComp.recordingDuration = 0 || this.annotationComp.recordingDuration;
        this.annotationComp.loadAnnotationData(recordingId);
      } else {
        console.warn('annotationComp not available yet — will retry shortly');
        // Retry once more after a short delay
        setTimeout(() => {
          if (this.annotationComp) {
            this.annotationComp.recordingId = recordingId;
            this.annotationComp.recordingDuration = this.selectedRecording?.duration || this.annotationComp.recordingDuration;
            this.annotationComp.loadAnnotationData(recordingId);
          } else {
            console.error('annotationComp ViewChild missing after retry');
          }
        }, 100);
      }
    }, 50);
  }

  closeAnnotationPanel(): void {
    this.showAnnotationsPanel = false;
    this.showTimeline = this.previousSidebarView === 'timeline';
  }

  private formatTimestamp(seconds: number): string {
    if (seconds == null || seconds < 0) return '';
    // console.log('Formatting timestamp for seconds:', seconds);
    let startedTimestamp = 0;
    if (this.selectedRecording?.startedAt) {
      const parsedDate = new Date(this.selectedRecording.startedAt);
      // console.log('Parsed date from startedAt:', parsedDate);
      // Ensure the parsed date is valid before getting the time
      if (!isNaN(parsedDate.getTime())) {
        startedTimestamp = parsedDate.getTime();
        // console.log('Started timestamp in ms:', startedTimestamp);

      }
    }
    const base = startedTimestamp > 0 ? startedTimestamp : Date.now();
    const isEpoch = seconds > 1e12;

    const absoluteMs = isEpoch ? seconds : base + seconds * 1000;

    return new Date(absoluteMs)
      .toLocaleString('en-CA', { hour12: false })
      .replace(',', '');
  }
  getCurrentPlayerTime() {
    console.log("getCurrentPlayerTime called", this.selectedRecording.startedAt, this.audioCurrentTime);
    return this.getFormattedTime();
  };
  getFormattedTime(): string {
    // 1. Parse the string into a local Date object
    const startDate = this.selectedRecording.startedAt === "undefined" || !this.selectedRecording.startedAt ? new Date() : this.selectedRecording.startedAt;
    const date = new Date(startDate);
    console.log("Parsed start date:", date, "Audio current time (seconds):", this.audioCurrentTime);
    // 2. Add the audio time (seconds) by converting it to milliseconds
    date.setMilliseconds(date.getMilliseconds() + (this.audioCurrentTime * 1000));

    // 3. Extract hours, minutes, and seconds
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // 4. Format with leading zeros to guarantee HH:mm:ss
    const pad = (num: number) => String(num).padStart(2, '0');
    console.log("Formatted time:", `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`);
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}
